const AppBehavior = {
  isShiels: window.STORE_CONTEXT?.isShiels === true,
  isGrahams: window.STORE_CONTEXT?.isGrahams === true,
  isWatchdepot: window.STORE_CONTEXT?.isWatchdepot === true
};

function isWatchdepotStore() {
  try {
    if (window.STORE_CONTEXT && window.STORE_CONTEXT.isWatchdepot === true) return true; 
    if (typeof window.location !== 'undefined' && window.location.hostname && String(window.location.hostname).indexOf("watchdepot") !== -1) return true;
  } catch (e) {}
  return false;
}

// Global error handler to catch Swym and SearchSpring errors
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  /* Store original createElement globally FIRST, before any override
     This ensures it's always accessible, even after we override document.createElement
     Don't use Document.prototype.createElement as it causes NotSupportedError
     Instead, create a wrapper that uses implementation method 
  */
  if (!window.__globalOriginalCreateElement__) {
    // Create a safe wrapper that uses implementation method
    window.__globalOriginalCreateElement__ = function(tagName) {
      try {
        if (document.implementation && document.implementation.createHTMLDocument) {
          const tempDoc = document.implementation.createHTMLDocument('');
          if (tempDoc && tempDoc.createElement) {
            const element = tempDoc.createElement(tagName || 'div');
            if (element) {
              try {
                return document.adoptNode(element);
              } catch (e) {
                return element;
              }
            }
          }
        }
      } catch (e) {
        // If implementation fails, return null
      }
      return null;
    };
  }
  
  // Prevent page reloads that might close the drawer
  // Intercept location.reload() to prevent unwanted page refreshes
  if (window.location && window.location.reload) {
    const originalReload = window.location.reload.bind(window.location);
    window.location.reload = function(forceReload) {
      // Only allow reload if drawer is not open or if it's explicitly requested
      const cartDrawer = document.getElementById("Cart-Drawer");
      const isDrawerOpen = cartDrawer && cartDrawer.classList.contains("active");
      
      if (isDrawerOpen && !window._pdpReloadScheduled) {
        // Drawer is open, prevent reload to keep drawer open
        console.warn("Page reload prevented to keep cart drawer open");
        return;
      }
      
      // Drawer is closed, allow reload
      return originalReload(forceReload);
    };
  }

  // Prevent navigation (assign/replace) when cart drawer is open so quantity updates don't cause full-page reload
  const isCartDrawerOpen = function() {
    const cartDrawer = document.getElementById("Cart-Drawer");
    return !!(cartDrawer && cartDrawer.classList.contains("active"));
  };
  if (window.location.assign) {
    const originalAssign = window.location.assign.bind(window.location);
    window.location.assign = function(url) {
      if (!window._pdpReloadScheduled && isCartDrawerOpen()) return;
      return originalAssign(url);
    };
  }
  if (window.location.replace) {
    const originalReplace = window.location.replace.bind(window.location);
    window.location.replace = function(url) {
      if (!window._pdpReloadScheduled && isCartDrawerOpen()) return;
      return originalReplace(url);
    };
  }
  
  // Intercept createElement globally to prevent SearchSpring NotSupportedError
  // SearchSpring uses: document.createElement(tagName, { is: '...' })
  // which causes: NotSupportedError: The result must not have attributes
  // Use native createElement for custom elements (tag contains '-') so Shopify Forms
  // and other apps can create elements like shopify-forms-embed with working shadow DOM
  const _nativeCreateElement = Document.prototype.createElement;
  
  document.createElement = function(tagName, options) {

    if (typeof tagName === 'string' && tagName.indexOf('-') !== -1) {
      try {
        return _nativeCreateElement.call(document, tagName);
      } catch (e) {
        // fall through to safe path if native throws
      }
    }
    // Wrap everything in a global try-catch to ensure no errors escape
    try {
      // Helper function to safely create element with multiple fallbacks
    // Never use document.createElement inside this function to avoid recursion
    // Wrap ALL calls in try-catch to prevent any errors from escaping
    const safeCreateElement = function(tag) {
      const validTag = tag && typeof tag === 'string' ? tag : 'div';
      
      // Use ONLY document.implementation.createHTMLDocument to avoid NotSupportedError
      // This method creates a new document and doesn't have the same restrictions
      // It's the ONLY safe method that never throws NotSupportedError
      try {
        if (document.implementation && document.implementation.createHTMLDocument) {
          const tempDoc = document.implementation.createHTMLDocument('');
          if (tempDoc && tempDoc.createElement) {
            const element = tempDoc.createElement(validTag);
            if (element && typeof element === 'object' && element.nodeType === 1) {
              // Adopt the element into the main document
              try {
                return document.adoptNode(element);
              } catch (e) {
                // If adoptNode fails, return the element anyway - it should still work
                return element;
              }
            }
          }
        }
      } catch (e) {
        // If implementation method fails, return null
        return null;
      }
      
      // If implementation method is not available, return null
      return null;
    };
    
    // Always use the global reference directly to ensure it's accessible
    // This avoids any closure issues and ensures the function is always available
    const originalFn = window.__globalOriginalCreateElement__;
    
    // If the original function is somehow missing, we're in trouble
    // This should never happen since we set it above, but if it does, try to fix it
    if (!originalFn || typeof originalFn !== 'function') {
      // If original function is missing, use safeCreateElement directly
      // This avoids any issues with trying to restore the function
      const result = safeCreateElement(tagName);
      if (result && typeof result === 'object' && result.nodeType === 1) {
        return result;
      }
      const divResult = safeCreateElement('div');
      if (divResult && typeof divResult === 'object' && divResult.nodeType === 1) {
        return divResult;
      }
      return null;
    }
    
    // SearchSpring and other libraries pass options with attributes that cause NotSupportedError
    // ALWAYS ignore options and use safeCreateElement helper which has multiple fallbacks
    // This prevents NotSupportedError regardless of what's passed
    // Wrap everything in try-catch to ensure no errors escape
    try {
      const result = safeCreateElement(tagName);
      if (result && typeof result === 'object' && result.nodeType === 1) {
        return result;
      }
      
      // If safeCreateElement returns null or invalid element, try with div as fallback
      const divResult = safeCreateElement('div');
      if (divResult && typeof divResult === 'object' && divResult.nodeType === 1) {
        return divResult;
      }
    } catch (e) {
      // If safeCreateElement itself throws an error, silently continue to fallback
      // Don't log to avoid console spam
    }
    
    // Ultimate fallback: Try one more time with implementation method
    // This is the ONLY safe method that doesn't cause NotSupportedError
    try {
      if (document.implementation && document.implementation.createHTMLDocument) {
        const tempDoc = document.implementation.createHTMLDocument('');
        if (tempDoc && tempDoc.createElement) {
          const element = tempDoc.createElement('div');
          if (element) {
            try {
              return document.adoptNode(element);
            } catch (e) {
              return element;
            }
          }
        }
      }
    } catch (e) {
      // If even this fails, return null
    }
    
    // Absolute last resort: Return null
    // Most libraries will handle null gracefully or retry
    return null;
    } catch (globalError) {
      // Catch ANY error that might escape and return a safe fallback
      // This ensures that NotSupportedError never reaches the caller
      // Use ONLY implementation method which never throws NotSupportedError
      try {
        if (document.implementation && document.implementation.createHTMLDocument) {
          const tempDoc = document.implementation.createHTMLDocument('');
          if (tempDoc && tempDoc.createElement) {
            const element = tempDoc.createElement('div');
            if (element) {
              try {
                return document.adoptNode(element);
              } catch (e) {
                return element;
              }
            }
          }
        }
      } catch (e) {
        // If even this fails, return null
      }
      // Return null as absolute last resort - prevents error from propagating
      return null;
    }
  };
  
  const originalErrorHandler = window.onerror;
  window.onerror = function(msg, url, lineNo, columnNo, error) {
    // Catch Swym and SearchSpring errors
    if (msg && typeof msg === 'string') {
      const msgLower = msg.toLowerCase();
      const urlStr = url ? url.toLowerCase() : '';
      
      // Early catch for Swym "t is not a function" errors - most common Swym error
      // This error occurs when Swym tries to call a function that doesn't exist
      if (msgLower === 't is not a function' || 
          msgLower.includes('t is not a function')) {
        // Silently prevent - this is a known Swym bug
        return true;
      }
      
      // PRIORITY 1: Catch error object with NotSupportedError name FIRST
      // This catches the error before it's converted to string
      if (error && error.name === 'NotSupportedError') {
        return true; // Suppress the error
      }
      
      // PRIORITY 2: Catch NotSupportedError in message string
      if (msgLower.includes('notsupportederror') || 
          msgLower.includes('failed to execute') && msgLower.includes('createelement')) {
        return true; // Suppress the error
      }
      
      // PRIORITY 3: Catch createElement errors with "result must not have attributes"
      if (msgLower.includes('createelement') && 
          (msgLower.includes('result must not have') || msgLower.includes('attributes'))) {
        return true; // Suppress the error
      }
      
      // PRIORITY 2: Catch SearchSpring NotSupportedError - most common error
      // Early catch for the specific error pattern from SearchSpring
      if (msgLower.includes('failed to execute') && 
          msgLower.includes('createelement') && 
          msgLower.includes('attributes')) {
        // This is the exact SearchSpring error pattern
        return true;
      }
      
      // PRIORITY 3: Catch NotSupportedError from any source (includes SearchSpring)
      if (msgLower.includes('notsupportederror')) {
        return true;
      }
      
      // PRIORITY 4: Catch SearchSpring bundle.js errors by URL (very reliable)
      // Also catch errors from app.js line 98 (our createElement override)
      if (urlStr.includes('bundle.js') || 
          urlStr.includes('searchspring') || 
          urlStr.includes('snapui') ||
          (urlStr.includes('app.js') && (lineNo === 98 || lineNo === 82 || lineNo === 44))) {
        // Silently prevent SearchSpring errors from breaking the application
        return true;
      }
      
      // PRIORITY 5: Catch "Failed to execute 'createElement'" errors (broad catch)
      if (msgLower.includes('failed to execute') && msgLower.includes('createelement')) {
        return true;
      }
      
      // PRIORITY 6: Catch any error mentioning "createElement" and "attributes" together
      if (msgLower.includes('createelement') && msgLower.includes('attributes')) {
        return true;
      }
      
      // PRIORITY 7: Catch errors from our createElement override (app.js line 98/82/44)
      // These are SearchSpring errors being caught by our override
      if (urlStr.includes('app.js') && 
          (lineNo === 98 || lineNo === 82 || lineNo === 44 || lineNo === 50 || lineNo === 66) &&
          (msgLower.includes('createelement') || msgLower.includes('notsupportederror'))) {
        return true;
      }
      
      // Catch Swym CORS errors
      if (msgLower.includes('cors') && 
          (msgLower.includes('swym') || urlStr.includes('swym') || urlStr.includes('swymrelay'))) {
        console.warn('Swym CORS error caught and prevented:', msg);
        // Prevent the error from breaking the application
        return true;
      }
      
      // Catch Swym "t is not a function" errors - broader catch
      // This is a common Swym error that occurs when a function is undefined
      if (msgLower.includes('t is not a function') || 
          (msgLower.includes('is not a function') && 
           (msgLower.includes('typeerror') || 
            urlStr.includes('swym') || 
            urlStr.includes('3233.js') || 
            urlStr.includes('wishlist') ||
            urlStr.includes('1928.js') ||
            urlStr.includes('5905.js') ||
            urlStr.includes('7658.js') ||
            !urlStr || urlStr === ''))) {
        // Silently prevent Swym errors from breaking the application
        return true;
      }
      
      // Catch TypeError from Swym files more broadly
      if ((msgLower.includes('typeerror') || 
           (error && error.name === 'TypeError')) &&
          (urlStr.includes('swym') || 
           urlStr.includes('3233.js') || 
           urlStr.includes('wishlist') ||
           urlStr.includes('1928.js') ||
           urlStr.includes('5905.js') ||
           urlStr.includes('7658.js'))) {
        // Silently prevent Swym TypeError from breaking the application
        return true;
      }
      
      // Catch Swym Server API errors
      if (msgLower.includes('swym server api error') || 
          (msgLower.includes('server api error') && urlStr.includes('swym'))) {
        console.warn('Swym Server API error caught and prevented:', msg);
        return true;
      }
    }
    
    // Call original error handler for other errors
    if (originalErrorHandler) {
      return originalErrorHandler.call(this, msg, url, lineNo, columnNo, error);
    }
    return false;
  };
  
  // Also catch unhandled promise rejections from Swym and SearchSpring
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason) {
      let errorMsg = '';
      let errorUrl = '';
      
      if (typeof event.reason === 'object' && event.reason.message) {
        errorMsg = event.reason.message.toString().toLowerCase();
      } else if (typeof event.reason === 'string') {
        errorMsg = event.reason.toLowerCase();
      }
      
      // Check if error is from Swym or SearchSpring
      const isSwymError = errorMsg.includes('swym') || 
                         errorMsg.includes('swymrelay') ||
                         errorMsg.includes('cors') ||
                         errorMsg.includes('t is not a function') ||
                         errorMsg.includes('is not a function') ||
                         errorMsg.includes('typeerror') ||
                         errorMsg.includes('server api error') ||
                         (event.reason && typeof event.reason === 'object' && 
                          event.reason.name === 'TypeError' &&
                          (errorMsg.includes('3233') || errorMsg.includes('wishlist')));
      
      const isSearchSpringError = errorMsg.includes('notsupportederror') ||
                                  errorMsg.includes('failed to execute') ||
                                  errorMsg.includes('createelement') ||
                                  (event.reason && typeof event.reason === 'object' && 
                                   event.reason.name === 'NotSupportedError');
      
      if (isSwymError || isSearchSpringError) {
        // Silently prevent third-party errors from being logged
        event.preventDefault();
      }
    }
  });
  
  // Intercept console.error to catch SearchSpring and Swym errors that might be logged directly
  const originalConsoleError = console.error;
  console.error = function(...args) {
    const errorStr = args.join(' ').toLowerCase();
    // Check if it's a SearchSpring NotSupportedError
    if (errorStr.includes('notsupportederror') && 
        (errorStr.includes('createelement') || errorStr.includes('bundle.js') || errorStr.includes('attributes'))) {
      // Silently ignore SearchSpring errors
      return;
    }
    // Check if it's a Swym error
    if (errorStr.includes('swym') ||
        errorStr.includes('t is not a function') ||
        errorStr.includes('typeerror') ||
        errorStr.includes('cart product tile') ||
        errorStr.includes('sfl buttons') ||
        errorStr.includes('save for later') ||
        (errorStr.includes('is not a function') && 
         (errorStr.includes('swym') || errorStr.includes('3233.js') || errorStr.includes('wishlist')))) {
      // Silently ignore Swym errors (including "No cart product tile element found for the given element selector for injecting SFL Buttons")
      return;
    }
    
    // Check if it's a Shopify Pay 404 error (common in preview stores, especially Edge browser)
    if (errorStr.includes('shopify_pay') || 
        errorStr.includes('accelerated_checkout') ||
        (errorStr.includes('404') && errorStr.includes('not found') && 
         (errorStr.includes('shopify') || errorStr.includes('shop_events')))) {
      // Silently ignore Shopify Pay 404 errors (not available in preview stores)
      return;
    }
    
    // Check if it's a JSON parse error from server errors (502, 503, etc.)
    // When server returns HTML error page instead of JSON
    if ((errorStr.includes('unexpected token') || errorStr.includes('not valid json')) &&
        (errorStr.includes('<!doctype') || errorStr.includes('not valid json'))) {
      // Silently ignore JSON parse errors from server error pages
      return;
    }
    
    // Check if it's a 502/503/504 server error (temporary server issues)
    if ((errorStr.includes('502') || errorStr.includes('503') || errorStr.includes('504')) &&
        (errorStr.includes('bad gateway') || errorStr.includes('service unavailable') || 
         errorStr.includes('gateway timeout') || errorStr.includes('cart.js'))) {
      // Silently ignore temporary server errors for cart.js
      return;
    }
    
    // Check if it's a SearchSpring wishlist error (bundle.js)
    // These are warnings about wishlist events that don't affect functionality
    if (errorStr.includes('error running wishlist events') ||
        errorStr.includes('recommend_side-cart') ||
        errorStr.includes('recommend_bundle') ||
        errorStr.includes('recommend_similar') ||
        errorStr.includes('recommend_cross-sell') ||
        (errorStr.includes('recommend_') && errorStr.includes('wishlist'))) {
      // Silently ignore SearchSpring wishlist errors (these don't affect functionality)
      return;
    }
    
    // Call original console.error for other errors
    originalConsoleError.apply(console, args);
  };
  
  // Intercept XMLHttpRequest errors from Swym and prevent undefined URLs
  if (window.XMLHttpRequest) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url, ...args) {
      this._swymUrl = url;
      
      // Prevent requests to undefined URLs
      if (url && typeof url === 'string' && (url.includes('/undefined') || url.includes('undefined'))) {
        console.warn('XMLHttpRequest: Blocked request to undefined URL:', url);
        return;
      }
      
      return originalOpen.apply(this, [method, url, ...args]);
    };
    
    XMLHttpRequest.prototype.send = function(...args) {
      const self = this;
      
      // Add error handler for Swym requests
      if (this._swymUrl && typeof this._swymUrl === 'string' && 
          (this._swymUrl.includes('swymrelay') || this._swymUrl.includes('swym'))) {
        this.addEventListener('error', function(event) {
          console.warn('Swym XMLHttpRequest error caught:', this._swymUrl);
          // Prevent error from propagating
          event.stopPropagation();
        });
        
        this.addEventListener('load', function() {
          // Check for CORS errors
          if (this.status === 0 && this._swymUrl.includes('swymrelay')) {
            console.warn('Swym CORS error detected, silently handling:', this._swymUrl);
          }
        });
      }
      
      // Handle Shopify Pay 404 errors (common in preview stores)
      if (this._swymUrl && typeof this._swymUrl === 'string' && 
          this._swymUrl.includes('shopify_pay/accelerated_checkout')) {
        this.addEventListener('load', function() {
          // Silently handle 404 errors for Shopify Pay (not available in preview stores)
          if (this.status === 404) {
            // Silently prevent error from being logged
            return;
          }
        });
        
        this.addEventListener('error', function(event) {
          // Silently prevent error from propagating
          event.stopPropagation();
        });
      }
      
      return originalSend.apply(this, args);
    };
  }
  
  // Reload PDP 1–2s after add-to-cart (fixes frozen addon dropdown). Only for PDPs with addons (e.g. rings, pendant).
  window.schedulePdpReloadAfterAddToCart = function() {
    if (window.location.pathname.indexOf("/products/") === -1) return;
    if (!document.querySelector("product-options-section")) return;
    if (window._pdpReloadScheduled) return;
    window._pdpReloadScheduled = true;
    window._preventCartReload = false;
    window._easifyAddToCartInProgress = false;
    var url = window.location.href;
    // Meta refresh (some browsers/apps ignore it, so we also use setTimeout)
    var meta = document.createElement("meta");
    meta.httpEquiv = "refresh";
    meta.content = "2;url=" + url;
    meta.setAttribute("data-pdp-reload", "1");
    if (document.head) document.head.appendChild(meta);
    // Fallback: force reload after 2s so it works even if meta refresh is stripped/ignored
    setTimeout(function() {
      if (window.location.pathname.indexOf("/products/") !== -1) {
        // Close drawer before navigation so desktop interceptors do not block
        const cartDrawer = document.getElementById("Cart-Drawer");

        if (cartDrawer) cartDrawer.classList.remove("active");
        document.body.classList.remove("open-cc");        
        window.location.href = url;
      }
    }, 2000);
  };

  // WD only: debounce PDP reload so "Add all to bag" (multiple add-to-cart requests) all complete before reload. Only for PDPs with addons.
  window._wdPdpReloadDebounceTimer = null;
  window.schedulePdpReloadAfterAddToCartDebounced = function() {
    if (window.location.pathname.indexOf("/products/") === -1) return;
    if (!document.querySelector("product-options-section")) return;
    if (window._pdpReloadScheduled) return;
    if (window._wdPdpReloadDebounceTimer) clearTimeout(window._wdPdpReloadDebounceTimer);
    window._wdPdpReloadDebounceTimer = setTimeout(function() {
      window._wdPdpReloadDebounceTimer = null;
      if (window._pdpReloadScheduled) return;
      if (typeof window.schedulePdpReloadAfterAddToCart === "function") window.schedulePdpReloadAfterAddToCart();
    }, 2800);
  };

  // Intercept fetch to prevent requests to undefined URLs, handle Shopify Pay errors, and open drawer for cart adds
  if (window.fetch) {
    const originalFetch = window.fetch;
    
    window.fetch = function(url, ...args) {
      // Check if URL contains undefined
      const urlStr = typeof url === 'string' ? url : (url && url.toString ? url.toString() : '');
      
      // Detect cart add requests (theme uses /cart/add, others use /cart/add.js) and open drawer + schedule PDP reload
      if (urlStr && urlStr.indexOf('/cart/add') !== -1) {
        return originalFetch.apply(this, [url, ...args]).then((response) => {
          // If successful, open drawer immediately
          if (response && response.ok) {
            // Open drawer immediately
            const openDrawer = () => {
              const cartDrawer = document.getElementById("Cart-Drawer");
              if (cartDrawer) {
                document.body.classList.add("open-cc");
                cartDrawer.classList.add("active");
                cartDrawer.focus();
                dispatchCustomEvent("cart-drawer:open");

                // WD: ensure instance exists (on IOS DOMContentLoaded can fire after add-to-cart, so refresh would never run)
                if (isWatchdepotStore() && !window.cartDrawerInstance && typeof CartDrawer !== "undefined") {
                  window.cartDrawerInstance = getCartDrawerInstance();
                }
                
                // Set flag to keep drawer open
                const cartDrawerInstance = window.cartDrawerInstance;
                if (cartDrawerInstance) {
                  cartDrawerInstance._keepDrawerOpen = true;
                  
                  // Refresh drawer after a delay to include add-ons (Easify Options may add them separately)
                  if (typeof cartDrawerInstance.refresh === 'function') {
                    setTimeout(() => { cartDrawerInstance.refresh(); }, 500);
                  }
                  // WD: "Add all to bag" does multiple adds; one extra refresh so cart shows all times on iPhone
                  if (isWatchdepotStore() && typeof cartDrawerInstance.refresh === 'function') {
                    setTimeout(() => { cartDrawerInstance.refresh(); }, 1000);
                  }
                }
              }
            };
            
            // Open immediately
            setTimeout(openDrawer, 50);
            // Reload PDP after add (WD: debounced so "Add all to bag")
            response.clone().json().then(function(data) {
              if (!data.status) {
                if (isWatchdepotStore() && typeof window.schedulePdpReloadAfterAddToCartDebounced === "function") window.schedulePdpReloadAfterAddToCartDebounced();
                else if (typeof window.schedulePdpReloadAfterAddToCart === "function") window.schedulePdpReloadAfterAddToCart();
              }
            }).catch(function() {});
          }
          
          return response;
        }).catch((error) => {
          throw error;
        });
      }
      
      return originalFetch.apply(this, [url, ...args]);
    };
  }
}

if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

/**
 * Prevent duplicate add-to-cart: throttle only when the SAME variant is added again within 1.5s.
 * Different variants (e.g. main product + add-on bundle) are allowed so bundles work.
 * Theme uses routes.cart_add_url (/cart/add); other scripts may use /cart/add.js.
 * Applies to both fetch and XMLHttpRequest.
 */
(function () {
  var lastCartAddTime = 0;
  var lastCartAddVariantId = null;
  var lastCartAddResult = null;
  var realFetch = window.fetch;
  var CART_ADD_THROTTLE_MS = 1500;

  function isCartAddUrl(url) {
    if (typeof url !== "string") return false;
    return url.indexOf("/cart/add") !== -1;
  }

  //Extract variant ID from cart add body (FormData or query string).
  function getVariantIdFromBody(body) {
    if (body == null) return null;
    try {
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        var id = body.get("id");
        return id != null ? String(id) : null;
      }
      if (typeof body === "string") {
        var match = body.match(/\bid=(\d+)\b/);
        return match ? match[1] : null;
      }
    } catch (e) {}
    return null;
  }

  function fakeCartAddResponse() {
    return lastCartAddResult
      ? JSON.stringify(lastCartAddResult)
      : JSON.stringify({ item_count: 1, items: [], message: "" });
  }

  //Return true only when we should throttle: same variant re-added within the time window.
  function shouldThrottleCartAdd(variantId) {
    var now = Date.now();
    if (!lastCartAddTime || now - lastCartAddTime >= CART_ADD_THROTTLE_MS) return false;
    if (variantId == null || lastCartAddVariantId == null) return false;
    return variantId === lastCartAddVariantId;
  }

  function storeCartAddResult(data) {
    if (data != null) lastCartAddResult = data;
  }

  window.__resetCartAddThrottle = function () {
    lastCartAddTime = 0;
    lastCartAddVariantId = null;
  }  

  // --- Throttle fetch ---
  // WD: do not add throttle wrapper at all so fetch stays as first wrapper only for Shiels and Grahams
  if (!isWatchdepotStore()) {
    window.fetch = function (url, opts) {
      var urlStr = typeof url === "string" ? url : (url && url.url) || "";
      if (isCartAddUrl(urlStr)) {
        var body = opts && opts.body;
        var variantId = getVariantIdFromBody(body);
        if (shouldThrottleCartAdd(variantId)) {
          return new Promise(function (resolve) {
            var waited = 0;
            var maxWait = 2200;
            function tryResolve() {
              if (lastCartAddResult) {
                resolve(
                  new Response(JSON.stringify(lastCartAddResult), {
                    status: 200,
                    headers: { "Content-Type": "application/json" },
                  })
                );
                return;
              }
              if (waited >= maxWait) {
                resolve(
                  new Response(fakeCartAddResponse(), {
                    status: 200,
                    headers: { "Content-Type": "application/json" },
                  })
                );
                return;
              }
              waited += 50;
              setTimeout(tryResolve, 50);
            }
            setTimeout(tryResolve, 0);
          });
        }
        lastCartAddTime = Date.now();
        lastCartAddVariantId = variantId;
        return realFetch.apply(this, arguments).then(function (response) {
          var clone = response.clone();
          try {
            clone.json().then(
              function (data) {
                storeCartAddResult(data);
              },
              function () {}
            );
          } catch (e) {}
          return response;
        });
      }
      return realFetch.apply(this, arguments);
    };
  }

  // --- Throttle XMLHttpRequest (Edge, jQuery.ajax, some apps) ---
  var OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    window.XMLHttpRequest = function () {
      var xhr = new OrigXHR();
      var origOpen = xhr.open;
      var origSend = xhr.send;
      var requestUrl = "";
      var requestMethod = "";

      xhr.open = function (method, url) {
        requestMethod = (method || "").toUpperCase();
        requestUrl = typeof url === "string" ? url : "";
        return origOpen.apply(this, arguments);
      };

      xhr.send = function (body) {
        if (requestMethod === "POST" && isCartAddUrl(requestUrl)) {
          var variantId = getVariantIdFromBody(body);
          
          if (!isWatchdepotStore() && shouldThrottleCartAdd(variantId)) {
            var self = this;

            setTimeout(function () {
              try {
                var json = fakeCartAddResponse();
                Object.defineProperty(self, "readyState", { value: 4, configurable: true });
                Object.defineProperty(self, "status", { value: 200, configurable: true });
                Object.defineProperty(self, "responseText", { value: json, configurable: true });
                Object.defineProperty(self, "response", { value: json, configurable: true });
                if (typeof self.onreadystatechange === "function") self.onreadystatechange();
                if (typeof self.onload === "function") self.onload();
              } catch (e) {}
            }, 10);
            return;
          }
          lastCartAddTime = Date.now();
          lastCartAddVariantId = variantId;
          var origOnReady = xhr.onreadystatechange;
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200 && xhr.responseText) {
              try {
                storeCartAddResult(JSON.parse(xhr.responseText));
              } catch (e) {}
              // WD only: open cart drawer and refresh when add-to-cart is done via XHR (Searchspring "add to all bag" on mobile use XHR)
              if (isWatchdepotStore()) {
                var cartDrawer = document.getElementById("Cart-Drawer");

                if (cartDrawer) {
                  document.body.classList.add("open-cc");
                  cartDrawer.classList.add("active");
                  cartDrawer.focus();
                  document.dispatchEvent(new CustomEvent("cart-drawer:open"));                  
                }

                function wdRefresh() {
                  if (!window.cartDrawerInstance && typeof CartDrawer !== "undefined") {
                    window.cartDrawerInstance = getCartDrawerInstance();
                  }

                  if (window.cartDrawerInstance && typeof window.cartDrawerInstance.refresh === "function") {
                    window.cartDrawerInstance.refresh();
                  }
                }

                setTimeout(wdRefresh, 450);
                setTimeout(wdRefresh, 1000);

                // Debounce PDP reload so all bundle adds complete before reload
                if (typeof window.schedulePdpReloadAfterAddToCartDebounced === "function") window.schedulePdpReloadAfterAddToCartDebounced();
              }
            }

            if (origOnReady) origOnReady.apply(this, arguments);
          };
        }

        return origSend.apply(this, arguments);
      };

      return xhr;
    };
  }
})();

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);

  document.dispatchEvent(event);
};

/**
*  @class
*  @function Quantity
*/
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.step = null;
      this.changeEvent = new Event("change", { bubbles: true });
      this.cartDrawer = null;
      this.itemRecords = [];
      this.subtract = null;
      this.add = null;
      this.shouldShowDiscountAmount = false;
      this.listenersAttached = false;
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.input = this.querySelector(".qty");
      if (!this.input) {
        console.warn("Quantity selector: input element not found");
        return;
      }
      
      this.step = parseFloat(this.input.getAttribute("step")) || 1;
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");
      
      // Add button functionality only if buttons exist and listeners not already attached
      if (this.subtract && this.add && !this.listenersAttached) {
        this.subtract.addEventListener("click", (e) => {
          e.preventDefault();
          this.change_quantity(-1 * this.step);
        });
        this.add.addEventListener("click", (e) => {
          e.preventDefault();
          this.change_quantity(1 * this.step);
        });
        this.listenersAttached = true;
      }
      
      this.validateQtyRules();
      this.classList.add("buttons_added");
      this.cartDrawer = document.querySelector("#Cart-Drawer");
      this.cartDrawerAllItems = this.cartDrawer ? this.cartDrawer.querySelectorAll(".product-cart-item") : [];

      if (this.cartDrawer && this.cartDrawerAllItems?.length > 0) {
        const totalDiscountAmount = this.cartDrawer.querySelector("#drawer-cart-discounted-amount");
        const totalSavedAmount = this.cartDrawer.querySelector("#drawer-cart-saved-amount");

        this.cartDrawerAllItems.forEach((item) => {
          const input = item.querySelector(`input[name="updates[]"]`);
          if (!input) return;
          const itemId = item.getAttribute("id");
          const currentQuantity = input.getAttribute("value");
          const { itemComparedPrice, itemCurrentPrice } = item.dataset;

          if (itemId && !this.itemRecords.some((record) => record.itemId === itemId)) {
            const newItemRecord = {
              itemId,
              itemComparedPrice: itemComparedPrice || itemCurrentPrice || "0",
              itemCurrentPrice: itemCurrentPrice || "0",
              quantity: currentQuantity,
            };
            this.itemRecords.push(newItemRecord);
          }
        });

        if (this.itemRecords.length > 0) {
          let totalDiscount = 0;
          let totalSaved = 0;

          this.itemRecords.forEach((record) => {
            const comparedPrice = parseFloat(record.itemComparedPrice.replace(/[$,]/g, "")) / 100 || 0; // Convert to dollars
            const currentPrice = parseFloat(record.itemCurrentPrice.replace(/[$,]/g, "")) / 100 || 0; // Convert to dollars
            const quantity = parseInt(record.quantity) || 0;
            // Calculate the total discount and total saved
            totalDiscount += comparedPrice * quantity;
            totalSaved += (comparedPrice - currentPrice) * quantity; // Calculate savings per item
          });
          // Round `totalDiscount` for display only
          totalDiscount = Math.round(totalDiscount * 100) / 100;
          const tolerance = 0.01; // Small tolerance for floating-point comparisons
          if (totalDiscountAmount && Math.abs(totalDiscount - totalSaved) > tolerance) {
            totalDiscountAmount.innerText = this.formatCurrency(totalDiscount);
          }
          if (totalSavedAmount && Math.abs(totalDiscount - totalSaved) > tolerance) {
            totalSavedAmount.innerText = `Total Saved: $${totalSaved.toFixed(2)}`; // Format as 2 decimal places but do not round the value
          }

          // Hides discounted amount when saved amount is near zero
          if (totalDiscountAmount) {
            if (Math.abs(totalSaved) < tolerance) {
              totalDiscountAmount.style.display = "none";
            } else {
              totalDiscountAmount.style.display = ""; // Reset to default display
            }
          }
        }
      }
    }

    change_quantity(change) {
      if (!this.input) {
        console.warn("Quantity selector: input element not found");
        return;
      }
      
      let quantity = Number(this.input.value);

      if (isNaN(quantity)) quantity = 1;

      const min = parseInt(this.input.getAttribute("min")) || 1;
      const max = parseInt(this.input.getAttribute("max")) || Infinity;

      quantity = Math.min(Math.max(quantity + change, min), max);

      // Update input value
      this.input.value = quantity;
      
      // Update the value attribute as well (for compatibility)
      this.input.setAttribute("value", quantity);

      // Dispatch change event to trigger cart update
      const changeEvent = new Event("change", { bubbles: true, cancelable: true });
      this.input.dispatchEvent(changeEvent);

      this.validateQtyRules();

      this.updateCartTotals();
    }

    updateCartTotals() {
      if (this.cartDrawer && this.cartDrawerAllItems?.length > 0) {
        const totalDiscountAmount = this.cartDrawer.querySelector("#drawer-cart-discounted-amount");
        const totalSavedAmount = this.cartDrawer.querySelector("#drawer-cart-saved-amount");

        this.itemRecords = [];
        this.cartDrawerAllItems.forEach((item) => {
          const input = item.querySelector(`input[name="updates[]"]`);
          if (!input) return;
          const itemId = item.getAttribute("id");
          const currentQuantity = input.getAttribute("value");
          const { itemComparedPrice, itemCurrentPrice } = item.dataset;

          if (itemId && !this.itemRecords.some((record) => record.itemId === itemId)) {
            const newItemRecord = {
              itemId,
              itemComparedPrice: itemComparedPrice || itemCurrentPrice || "0",
              itemCurrentPrice: itemCurrentPrice || "0",
              quantity: currentQuantity,
            };
            this.itemRecords.push(newItemRecord);
          }
        });

        let totalDiscount = 0;
        let totalSaved = 0;

        this.itemRecords.forEach((record) => {
          const comparedPrice = parseFloat(record.itemComparedPrice.replace(/[$,]/g, "")) / 100 || 0; // Convert to dollars
          const currentPrice = parseFloat(record.itemCurrentPrice.replace(/[$,]/g, "")) / 100 || 0; // Convert to dollars
          const quantity = parseInt(record.quantity) || 0;
          // Calculate the total discount and total saved
          totalDiscount += comparedPrice * quantity;
          totalSaved += (comparedPrice - currentPrice) * quantity; // Calculate savings per item
        });

        // Round `totalDiscount` for display only
        totalDiscount = Math.round(totalDiscount * 100) / 100;

        const tolerance = 0.01; // Small tolerance for floating-point comparisons
        if (totalDiscountAmount && Math.abs(totalDiscount - totalSaved) > tolerance) {
          totalDiscountAmount.innerText = this.formatCurrency(totalDiscount);
        }
        if (totalSavedAmount && Math.abs(totalDiscount - totalSaved) > tolerance) {
          totalSavedAmount.innerText = `Total Saved: $${totalSaved.toFixed(2)}`; // Format as 2 decimal places but do not round the value
        }

        // Hides discounted amount when saved amount is near zero
        if (totalDiscountAmount) {
          if (Math.abs(totalSaved) < tolerance) {
            totalDiscountAmount.style.display = "none";
          } else {
            totalDiscountAmount.style.display = ""; // Reset to default display
          }
        }
      }
    }
    validateQtyRules() {
      if (!this.input) return;
      
      const value = parseInt(this.input.value);
      const min = parseInt(this.input.min) || 1;
      const max = parseInt(this.input.max) || Infinity;

      if (this.subtract) {
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.add) {
        this.add.classList.toggle("disabled", value >= max);
      }
    }

    formatCurrency(amount) {
      return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
*  @class
*  @function ArrowSubMenu
*/
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
*  @class
*  @function ProductCard
*/
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = null;
      this.image = null;
      this.additional_images = null;
      this.additional_images_nav = null;
      this.quick_add = null;
      this.wishlistButton = null;
      this.wishlistCount = null;
      this.allWishlistedProductsAmount = null;
      this.productTitle = null;
      this._boundQuickAdd = this.quickAdd.bind(this);
      this._boundWishlistClick = this.handleWishlistClick.bind(this);
    }
    
    connectedCallback() {
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(".product-featured-image-link .product-primary-image");
      this.additional_images = this.querySelectorAll(".product-secondary-image");
      this.additional_images_nav = this.querySelectorAll(".product-secondary-images-nav li");
      this.quick_add = this.querySelector(".product-card--add-to-cart-button-simple");
      this.wishlistButton = this.querySelector("button.swym-button.swym-heart");
      this.productTitle = this.querySelector(".product-card-title");
      this.wishlistCount = document.getElementById("wishlist-item-count");

      if (!window.__wishlistInitialized) {
        window.__wishlistInitialized = true;

        setTimeout(() => {
          document.querySelectorAll("product-card").forEach((card) => {
            card.updateWishlistCounter?.();
            card.checkInitialWishlistState?.();
          });
        }, 2000);
      }

      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.wishlistButton) {
        this.addToWishlist();
      }

      // Also handle product page wishlist buttons
      this.setupProductPageWishlist();
    }
    
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };

      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      
      /**
       * @updated 26/03/2026
       * @updateDescription It was updated to removes multiple global listeners per card and performs the preload right at card initialization.
       * @author Updated by Renan Rodrigues
       */
      images.forEach((image) => {
        if (image) {
          lazySizes.loader.unveil(image);
        }
      });
    }

    /**
    * @updated 26/03/2026 
    * @description Remove per-swatch `window.load` listeners and replace with lightweight inline image preload to reduce unnecessary main-thread overhead.
    * @author Updated by Renan Rodrigues
    */
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "";

      swatch_list.forEach((swatch) => {
        if (swatch.dataset.srcset) {
          const preloadImage = new Image();
          preloadImage.srcset = swatch.dataset.srcset;
        }

        swatch.addEventListener("mouseover", function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }

          swatch.classList.add("active");
        });

        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }

    enableQuickAdd() {
      if (!this.quick_add) return;
      this.quick_add.removeEventListener("click", this._boundQuickAdd);
      this.quick_add.addEventListener("click", this._boundQuickAdd);
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add && this.quick_add.disabled) {
        return;
      }

      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData(this.form);

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          // Salesforce Interaction Studio tracking
          if (window.location.hostname.includes('shiels')) {
            const addedProduct = response.hasOwnProperty("items") ? response.items[0] : response;

            if (window.theme && window.theme.trackAddToCart) {
              window.theme.trackAddToCart(addedProduct);
            }

            dispatchCustomEvent("cart:item-added", {
              product: addedProduct,
            });
          } else {
            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items") ? response.items[0] : response,
            });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }

    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== "undefined") {
          window.cartDrawerInstance = getCartDrawerInstance();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById("Cart-Drawer")) {
        document.body.classList.add("open-cc");
        document.getElementById("Cart-Drawer").classList.add("active");

        dispatchCustomEvent("cart-drawer:open");
      }
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    handleWishlistClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const button = event.target.closest("button.swym-button.swym-heart");
      
      if (button) {
        const productId = button.getAttribute("data-product-id");
        const variantId = button.getAttribute("data-variant-id");
        const productUrl = button.getAttribute("data-product-url");

        this.toggleWishlistItem(productId, variantId, productUrl, button);
      }
    }

    addToWishlist() {
      if (!this.wishlistButton) return;

      this.wishlistButton.removeEventListener("click", this._boundWishlistClick);
      this.wishlistButton.addEventListener("click", this._boundWishlistClick);
    }

    toggleWishlistItem(productId, variantId, productUrl, button) {
      try {
        // Get current wishlist
        let swymProducts = localStorage.getItem("swym-products");
        if (!swymProducts) {
          swymProducts = JSON.stringify({ all: [] });
        }

        const parsedProducts = JSON.parse(swymProducts);
        const wishlistItems = parsedProducts.all || [];

        // Check if product is already in wishlist
        const existingIndex = wishlistItems.findIndex(item => item.empi === productId);

        if (existingIndex >= 0) {
          // Remove from wishlist
          wishlistItems.splice(existingIndex, 1);
          button.classList.remove('swym-added');
          button.classList.remove('disabled');
        } else {
          // Add to wishlist
          const wishlistItem = {
            empi: productId,
            epi: variantId,
            dt: button.closest('product-card')?.querySelector('.product-card-title')?.textContent || 'Product',
            du: productUrl,
            iu: button.closest('product-card')?.querySelector('img')?.src || '',
            pr: 0, // Price can be added later if needed
            ct: 'Product'
          };

          wishlistItems.push(wishlistItem);
          button.classList.add('swym-added');
          button.classList.add('disabled');
        }

        // Save back to localStorage
        parsedProducts.all = wishlistItems;
        localStorage.setItem("swym-products", JSON.stringify(parsedProducts));

        // Update counter
        this.updateWishlistCounter();

        // Force visual update for product page buttons
        this.updateButtonVisualState(button);

      } catch (error) {
        console.error("Error toggling wishlist item:", error);
      }
    }

    updateWishlistCounter() {
      try {
        // Get wishlist count from Swym localStorage
        const swymProducts = localStorage.getItem("swym-products");
        if (swymProducts) {
          const parsedProducts = JSON.parse(swymProducts);
          const wishlistItems = parsedProducts.all || [];

          if (this.wishlistCount) {
            this.wishlistCount.innerText = wishlistItems.length;
          }
        }
      } catch (error) {
        console.error("Error updating wishlist counter:", error);
      }
    }

    updateButtonVisualState(button) {
      try {
        // Check if product is in wishlist and update visual state
        const swymProducts = localStorage.getItem("swym-products");
        if (swymProducts) {
          const parsedProducts = JSON.parse(swymProducts);
          const wishlistItems = parsedProducts.all || [];
          const productId = button.getAttribute("data-product-id");

          if (productId) {
            const isInWishlist = wishlistItems.some(item => item.empi === productId);

            if (isInWishlist) {
              button.classList.add('swym-added');
              button.classList.add('disabled');
            } else {
              button.classList.remove('swym-added');
              button.classList.remove('disabled');
            }
          }
        }
      } catch (error) {
        console.error("Error updating button visual state:", error);
      }
    }

    checkInitialWishlistState() {
      if (this.wishlistButton) {
        this.updateButtonVisualState(this.wishlistButton);
      }
    }

    setupProductPageWishlist() {
      if (window.__productPageWishlistInitialized) return;
      window.__productPageWishlistInitialized = true;

      const productPageWishlistButtons = document.querySelectorAll('#product-page-addToWishlist');

      productPageWishlistButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const productId = button.getAttribute("data-product-id");
          const variantId = button.getAttribute("data-variant-id");
          const productUrl = button.getAttribute("data-product-url");

          if (productId && variantId && productUrl) {
            this.toggleWishlistItem(productId, variantId, productUrl, button);
          }
        });

        this.updateButtonVisualState(button);
      });
    }
  }
  customElements.define("product-card", ProductCard);
}

/**
*  @class
*  @function ProductCardSmall
*  @updated 26/03/2026
*  @author Updated by Renan Rodrigues
*/
if (!customElements.get("product-card-small")) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains("quick-add-to-card--true");
      this.id = this.dataset.id;
      this.url = this.dataset.url;
      this._boundAddToCart = this.addToCart.bind(this);
    }

    connectedCallback() {
      // Safety check: ensure this element is valid
      if (!this || !this.isConnected) {
        return;
      }
      
      if (this.quick_add_enabled) {
        // Use requestAnimationFrame to ensure DOM is ready, especially for dynamically created elements
        requestAnimationFrame(() => {
          // Double check element is still connected before setting listeners
          if (this && this.isConnected && typeof this.setEventListeners === 'function') {
            try {
        this.setEventListeners();
            } catch (e) {
              console.warn("ProductCardSmall: Error in connectedCallback:", e);
            }
          }
        });
      }
    }

    setEventListeners() {
      // Early return if element is not connected to DOM
      if (!this || !this.isConnected) {
        return;
      }
      
      // Initialize retry counter if not exists
      if (!this._setEventListenersRetryCount) {
        this._setEventListenersRetryCount = 0;
      }
      
      // Query for button each time to ensure it exists (especially for dynamically created elements)
      // IMPORTANT: Only look for actual button elements, not quick-view or other elements
      let buttonElement = null;
      let anyButton = null;
      
      try {
        if (this.querySelector) {
          buttonElement = this.querySelector("button.product-card-small--add-to-cart-button");
          anyButton = this.querySelector("button");
        }
      } catch (e) {
        console.warn("ProductCardSmall: Error querying for button:", e);
        this.button = null;
        return;
      }
      
      // Only use button if it's actually a button element
      if (buttonElement && buttonElement.nodeName && buttonElement.nodeName.toLowerCase() === 'button') {
        this.button = buttonElement;
      } else if (anyButton && anyButton.nodeName && anyButton.nodeName.toLowerCase() === 'button') {
        this.button = anyButton;
      } else {
        this.button = null;
      }
      
      // Never access addEventListener without checking button exists and is valid
      // Only proceed if button exists, is a valid button element, and has addEventListener method
      if (this.button && 
          this.button.nodeName && 
          this.button.nodeName.toLowerCase() === 'button' &&
          typeof this.button.addEventListener === 'function') {
        try {
          // Final safety check before accessing addEventListener - triple check everything
          const button = this.button;
          if (!button || 
              !button.nodeName || 
              button.nodeName.toLowerCase() !== 'button' ||
              typeof button.addEventListener !== 'function') {
            console.warn("ProductCardSmall: Button is not valid for event listener");
            this.button = null;
            return;
          }
          
          // Remove existing listener if any to avoid duplicates
          button.removeEventListener("click", this._boundAddToCart);
          button.addEventListener("click", this._boundAddToCart);

          // Reset retry counter on success
          this._setEventListenersRetryCount = 0;
        } catch (e) {
          console.warn("ProductCardSmall: Error setting event listener:", e);
          this.button = null;
        }
      } else if (this.quick_add_enabled && this._setEventListenersRetryCount < 3) {
        // If button not found and quick add is enabled, try again after a short delay
        // Limit retries to prevent infinite loops
        this._setEventListenersRetryCount++;
        setTimeout(() => {
          if (this && this.setEventListeners) {
            this.setEventListeners();
          }
        }, 50);
      } else if (this.quick_add_enabled && this._setEventListenersRetryCount >= 3) {
        // After 3 retries, give up and log a warning
        console.warn("ProductCardSmall: Button not found after multiple attempts");
        this._setEventListenersRetryCount = 0;
      }
    }

    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }

    addToCart() {
      // Ensure button exists before using it
      if (!this.button) {
        this.button = this.querySelector("button.product-card-small--add-to-cart-button") || 
                      this.querySelector("button") ||
                      this.querySelector(".product-card-small--add-to-cart-button");
      }
      
      if (!this.button) {
        console.warn("ProductCardSmall: Button not found, cannot add to cart");
        return;
      }
      
      this.button.classList.add("loading");
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData(this.form);

      formData.append("id", this.id);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          // Salesforce Interaction Studio tracking
          if (window.location.hostname.includes('shiels')) {
            const addedProduct = response.hasOwnProperty("items") ? response.items[0] : response
            if (window.theme && window.theme.trackAddToCart) {
              window.theme.trackAddToCart(addedProduct);
            }
            dispatchCustomEvent("cart:item-added", {
              product: addedProduct,
            });
          } else {
            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items") ? response.items[0] : response,
            });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // Ensure button still exists before modifying it
          if (this.button) {
          this.button.classList.remove("loading");
          this.button.removeAttribute("aria-disabled");
          }
        });
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== "undefined") {
          window.cartDrawerInstance = getCartDrawerInstance();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });
      if (document.getElementById("Cart-Drawer")) {
        document.body.classList.add("open-cc");
        document.getElementById("Cart-Drawer").classList.add("active");
        dispatchCustomEvent("cart-drawer:open");
      }
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card-small", ProductCardSmall);
}

/**
*  @class
*  @function PanelClose
*/
class PanelClose extends HTMLElement {
  constructor() {
    super();
    let cc = document.querySelector(".click-capture");

    // Add functionality to buttons
    this.addEventListener("click", (e) => this.close_panel(e));
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          document.querySelectorAll(".side-panel").forEach((panel) => {
            if (document.body.classList.contains("open-cc--product")) {
              document.body.classList.remove("open-cc--product");

              setTimeout(() => {
                document.querySelector("#Product-Drawer-Content").innerHTML = "";
              }, 260);
            } else {
              if (panel.classList.contains("cart-drawer")) {
                document.getElementById("cart-drawer-toggle").focus();
                // Clear flag when user manually closes drawer with ESC
                const cartDrawerInstance = window.cartDrawerInstance;
                if (cartDrawerInstance) {
                  cartDrawerInstance._keepDrawerOpen = false;
                }
              }
              document.body.classList.remove("open-cc");
            }
            panel.classList.remove("active");
          });
        }
      }
    });
    cc.addEventListener("click", (e) => {
      let panel = document.querySelector(".side-panel.active");
      const stickyHeader = document.querySelector(".header--sticky");
      if (stickyHeader && stickyHeader.classList.contains("hidden")) {
        stickyHeader.classList.remove("hidden");
      }

      if (panel) {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
        // Clear flag when user manually closes drawer
        if (panel.classList.contains("cart-drawer")) {
          const cartDrawerInstance = window.cartDrawerInstance;
          if (cartDrawerInstance) {
            cartDrawerInstance._keepDrawerOpen = false;
          }
        }
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = null;
    const stickyHeader = document.querySelector(".header--sticky");
    if (stickyHeader && stickyHeader.classList.contains("hidden")) {
      stickyHeader.classList.remove("hidden");
    }

    if (e.target) {
      panel = e.target.closest(".side-panel");
      if (panel) {
        panel.classList.remove("active");
        // Clear flag when user manually closes drawer
        if (panel.classList.contains("cart-drawer")) {
          const cartDrawerInstance = window.cartDrawerInstance;
          if (cartDrawerInstance) {
            cartDrawerInstance._keepDrawerOpen = false;
          }
        }
      }
    }
    if (document.body.classList.contains("open-cc--product")) {
      document.body.classList.remove("open-cc--product");
      setTimeout(() => {
        document.querySelector("#Product-Drawer-Content").innerHTML = "";
      }, 260);
    } else {
      document.body.classList.remove("open-cc");
    }
  }
}
customElements.define("side-panel-close", PanelClose);

/**
*  @class
*  @function CartDrawer
*
*  @updated 26/03/2026
*  @updateDescription Updated CartDrawer class to include a debounced refresh method, continuous monitoring for strikethrough removal, and enhanced event handling for cart updates and drawer interactions.
*  @author Updated by Renan Rodrigues
*/
class CartDrawer {
  constructor() {
    this._cartCounterLastFetchAt = 0;
    this._cartCounterFetchPromise = null;
    this._cartCountElements = null;
    this._refreshTimer = null;
    
    this.container = document.getElementById("Cart-Drawer");
    if (!this.container) {
      return;
    }

    let button = document.getElementById("cart-drawer-toggle");
    this.lastRefreshTime = 0;
    this.refreshDelay = 50; // Delay in milliseconds before cart refresh

    // Detect if we're on a PDP (product-options-section exists there) to avoid installing global cart-add interception on PDP.
    const productOptionsSection = document.querySelector("product-options-section");

    if (
      AppBehavior.isShiels &&
      !productOptionsSection &&
      window.ShielsEnhancements?.setupGlobalCartAddRefresh
    ) {
      window.ShielsEnhancements.setupGlobalCartAddRefresh();
    }

    if (productOptionsSection) {
      this.observeAddToCartRequests();
      // Also set up direct monitoring for easify options
      this.setupEasifyMonitoring();
    }

    // Add functionality to drawer mobile buttons
    button?.addEventListener("click", (e) => {
      e.preventDefault();

      document.body.classList.add("open-cc");
      this.container.classList.add("active");
      this.container.focus();
      this.startStrikethroughRemovalMonitor();      
      this.requestRefresh();

      // Also ensure add-ons are disabled when drawer opens (after a delay to allow DOM to render)
      // Call immediately and multiple times to ensure it works
      requestAnimationFrame(() => {
        this.removeStrikethroughFromMainProducts();
        this.hideQuantitySelectorForAddOns();
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 200);
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 500);
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 1000);
      });
      dispatchCustomEvent("cart-drawer:open");
    });

    // Add functionality to desktop button
    let buttonDesktop = document.getElementById("cart-drawer-toggle-desktop");

    buttonDesktop?.addEventListener("click", (e) => {
      e.preventDefault();
      
      document.body.classList.add("open-cc");
      this.container.classList.add("active");
      this.container.focus();
      this.startStrikethroughRemovalMonitor();      
      this.requestRefresh();

      // Also ensure add-ons are disabled when drawer opens (after a delay to allow DOM to render)
      // Call immediately and multiple times to ensure it works
      requestAnimationFrame(() => {
        this.removeStrikethroughFromMainProducts();
        this.hideQuantitySelectorForAddOns();
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 200);
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 500);
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 1000);
      });
      dispatchCustomEvent("cart-drawer:open");
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener("cart:refresh", (event) => {
      this.requestRefresh(0);
    });

    // Listen for cart:item-added events to update cart counter, refresh drawer, and OPEN drawer
    document.addEventListener("cart:item-added", (event) => {
      // Open drawer immediately when item is added
      if (document.getElementById("Cart-Drawer")) {
        document.body.classList.add("open-cc");
        document.getElementById("Cart-Drawer").classList.add("active");
        document.getElementById("Cart-Drawer").focus();
        dispatchCustomEvent("cart-drawer:open");
      }
      
      this.updateCartCounter();
      // Set flag to keep drawer open before refresh
      this._keepDrawerOpen = true;
      // Refresh drawer after a short delay to ensure server has updated
      setTimeout(() => {
        this.refresh();
        // Ensure drawer stays open
        if (document.getElementById("Cart-Drawer")) {
          document.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
        }
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
      }, this.requestRefresh(0));
    });
    
    // Listen for cart-drawer:open event to open drawer and ensure add-ons are disabled
    document.addEventListener("cart-drawer:open", () => {
      // Always ensure drawer is open when this event fires
      if (this.container) {
        // Open the drawer physically if it's not already open
        document.body.classList.add("open-cc");
        this.container.classList.add("active");
        this.container.focus();
        
        // Set flag to keep drawer open during refresh
        this._keepDrawerOpen = true;
        
        // Start continuous strikethrough removal monitor
        this.startStrikethroughRemovalMonitor();
        
        // Refresh cart contents after a delay to ensure server has updated
        // This is important when adding products from PDP
        setTimeout(() => {
        this.refresh();
      }, this.requestRefresh(0));
      }
      
      // Use multiple delays to catch DOM changes at different stages
      // This must run even if refresh() hasn't completed yet
      requestAnimationFrame(() => {
        this.removeStrikethroughFromMainProducts();
        this.hideQuantitySelectorForAddOns();
        
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 100);
        
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 300);
        
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 500);
        
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 800);
        
        setTimeout(() => {
          this.removeStrikethroughFromMainProducts();
          this.hideQuantitySelectorForAddOns();
        }, 1200);
      });
    });
    
    // Monitor when drawer is closed to clean up interval and notify PDP (e.g. Easify dropdown)
    const drawerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isActive = this.container.classList.contains('active');
          if (!isActive) {
            // Drawer closed, stop strikethrough removal monitor
            this.stopStrikethroughRemovalMonitor();
            if (this._saveLaterMutationRaf != null) {
              cancelAnimationFrame(this._saveLaterMutationRaf);
              this._saveLaterMutationRaf = null;
            }
            this.updateCartCounter();
            dispatchCustomEvent('cart-drawer:closed');
            // WD: reset add-to-cat throttle state so next "add to all bag" is not affected by precious click
            if (isWatchdepotStore() && typeof window.__resetCartAddThrottle === 'function') {
              window.__resetCartAddThrottle();
            }
            // Refresh cart count again after DOM settles (avoids header badges disappearing)
            var self = this;
            setTimeout(function() { self.updateCartCounter(); }, 200);
          } else {
            // Drawer opened, start strikethrough removal monitor
            this.startStrikethroughRemovalMonitor();
          }
        }
      });
    });
    if (this.container) {
      drawerObserver.observe(this.container, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    this.container.addEventListener("change", this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();

    if (AppBehavior.isShiels || AppBehavior.isGrahams) {
      this.setupDrawerDocumentDelegation();
      this.setupCheckoutSubmitGuard();
    }

    // Terms checkbox
    this.termsCheckbox();
    
    // Hide quantity selector for add-ons immediately on load
    requestAnimationFrame(() => {
      this.hideQuantitySelectorForAddOns();
      this.removeStrikethroughFromMainProducts();
      this.disableAddOnLinks();
      this.styleSwymSaveForLaterLinks();
    });
    
    // Also call after short delays to catch any late-rendering
    setTimeout(() => {
      this.hideQuantitySelectorForAddOns();
      this.removeStrikethroughFromMainProducts();
      this.disableAddOnLinks();
      this.styleSwymSaveForLaterLinks();
    }, 10);
    setTimeout(() => {
      this.hideQuantitySelectorForAddOns();
      this.removeStrikethroughFromMainProducts();
      this.disableAddOnLinks();
      this.styleSwymSaveForLaterLinks();
    }, 50);
    setTimeout(() => {
      this.hideQuantitySelectorForAddOns();
      this.removeStrikethroughFromMainProducts();
      this.disableAddOnLinks();
      this.styleSwymSaveForLaterLinks();
    }, 150);
    setTimeout(() => {
      this.hideQuantitySelectorForAddOns();
      this.removeStrikethroughFromMainProducts();
      this.disableAddOnLinks();
      this.styleSwymSaveForLaterLinks();
    }, 300);
    
    // Set up observer to continuously monitor and fix
    this.setupAddOnObserver();
    
    // Listen for cart drawer open events
    this.setupCartDrawerOpenListener();
  }

  /**
   * @description Coalesce multiple rapid `refresh()` calls into a single scheduled execution to prevent redundant updates, 
   * reduce unnecessary DOM/network work, and improve cart drawer performance without changing existing behavior.
   * @updated 09/04/2026
   * @author Renan Rodrigues
   */
  requestRefresh(delay = this.refreshDelay) {
    if (this._refreshTimer) {
      clearTimeout(this._refreshTimer);
    }

    this._refreshTimer = setTimeout(() => {
      this._refreshTimer = null;
      this.refresh();
    }, delay);
  }
  
  /**
   * Setup MutationObserver to continuously monitor and fix add-on display
   */
  setupAddOnObserver() {
    if (!this.container) return;
    
    const observer = new MutationObserver(() => {
      this.hideQuantitySelectorForAddOns();
      this.removeStrikethroughFromMainProducts();
      this.disableAddOnLinks();
      this.styleSwymSaveForLaterLinks();
    });
    
    observer.observe(this.container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-is-addon']
    });
    
    /**
     * @description Also use interval as backup - more frequent.
     * 
     * @updated 27/03/2026
     * @updateDescription Replace setInterval from 100 to 300ms.
     * @author Updated by Renan Rodrigues
     */
    setInterval(() => {
      if (this.container && this.container.classList.contains('active')) {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }
    }, 300);
    
    // Start continuous strikethrough removal monitor
    this.startStrikethroughRemovalMonitor();
  }

  observeAddToCartRequests() {
    const self = this;
    
    // Store original fetch if not already stored (to avoid multiple wrappings)
    if (!window._originalFetchStored) {
      window._originalFetchStored = window.fetch;
    }
    const originalFetch = window._originalFetchStored;
    
    // Only wrap fetch once
    if (window._fetchWrappedForCart) {
      return;
    }
    window._fetchWrappedForCart = true;
    
    // Intercept fetch requests to /cart/add or /cart/add.js to open drawer and schedule PDP reload
    window.fetch = function(...args) {
      const url = args[0];
      const isCartAdd = typeof url === "string" && url.indexOf("/cart/add") !== -1;
      
      if (isCartAdd) {
        // Open drawer IMMEDIATELY when easify options adds products (before fetch completes)
        const cartDrawer = document.getElementById("Cart-Drawer");
        if (cartDrawer) {
          document.body.classList.add("open-cc");
          cartDrawer.classList.add("active");
          cartDrawer.focus();
          dispatchCustomEvent("cart-drawer:open");
        }
        
        // After fetch completes, refresh cart and ensure drawer stays open
        return originalFetch.apply(this, args).then((response) => {
          // Check if response is successful
          if (response.ok) {
            // Try to read response to check for errors
            response.clone().json().then((data) => {
              // Only proceed if no error status
              if (!data.status) {
                // Reload PDP after add (WD: debounced so "add all to bag" multiple requests don't cause multiple reloads)
                if (typeof isWatchdepotStore === "function" && isWatchdepotStore() && typeof window.schedulePdpReloadAfterAddToCartDebounced === "function") window.schedulePdpReloadAfterAddToCartDebounced();
                else if (typeof window.schedulePdpReloadAfterAddToCart === "function") window.schedulePdpReloadAfterAddToCart();

                // Refresh cart drawer after a short delay to ensure server processed
                setTimeout(() => {
                  self.refresh();
                  // Ensure drawer stays open
                  const cartDrawer = document.getElementById("Cart-Drawer");
                  if (cartDrawer) {
                    document.body.classList.add("open-cc");
                    cartDrawer.classList.add("active");
                  }
                  // Hide quantity selectors for add-ons
                  self.hideQuantitySelectorForAddOns();
                }, 200);
              }
            }).catch(() => {
              // If JSON parsing fails, still refresh drawer
              setTimeout(() => {
                self.refresh();
                const cartDrawer = document.getElementById("Cart-Drawer");
                if (cartDrawer) {
                  document.body.classList.add("open-cc");
                  cartDrawer.classList.add("active");
                }
              }, 200);
            });
          }
          
          return response;
        }).catch((error) => {
          // Even on error, try to keep drawer open
          return Promise.reject(error);
        });
      }
      
      return originalFetch.apply(this, args);
    };

    // Also use PerformanceObserver as backup
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.initiatorType === "fetch" && entry.name.indexOf("/cart/add") !== -1) {
          // Open drawer when add-ons are added via easify options (backup method)
          setTimeout(() => {
            const cartDrawer = document.getElementById("Cart-Drawer");
            if (cartDrawer && !cartDrawer.classList.contains("active")) {
              document.body.classList.add("open-cc");
              cartDrawer.classList.add("active");
              cartDrawer.focus();
              dispatchCustomEvent("cart-drawer:open");
            }
            // Hide quantity selectors for add-ons
            self.hideQuantitySelectorForAddOns();
          }, 100);
          
          self.refresh();
        }
      }
    });

    observer.observe({ entryTypes: ["resource"] });
  }

  /**
   * Setup direct monitoring for easify options to open drawer when products are added
   */
  setupEasifyMonitoring() {
    const self = this;
    
    // Prevent ALL types of page navigation/reload when easify adds products with add-ons
    if (!window._locationNavigationIntercepted) {
      window._locationNavigationIntercepted = true;
      
      // Intercept window.location.reload
      const originalLocationReload = window.location.reload;
      window.location.reload = function() {
        if (window._preventCartReload || window._easifyAddToCartInProgress) {
          const cartDrawer = document.getElementById("Cart-Drawer");
          if (cartDrawer) {
            document.body.classList.add("open-cc");
            cartDrawer.classList.add("active");
            if (typeof CartDrawer !== "undefined") {
              const cartDrawerInstance = getCartDrawerInstance();
              cartDrawerInstance.refresh();
              cartDrawerInstance.hideQuantitySelectorForAddOns();
            }
          }
          return; // Prevent reload
        }
        return originalLocationReload.apply(this, arguments);
      };
      
      // Intercept window.location.href (setter)
      const locationDescriptor = Object.getOwnPropertyDescriptor(window, 'location') || 
                                  Object.getOwnPropertyDescriptor(window.constructor.prototype, 'location');
      if (locationDescriptor && locationDescriptor.set) {
        const originalLocationSetter = locationDescriptor.set;
        const isDrawerOpenForLocation = function() {
          const cartDrawer = document.getElementById("Cart-Drawer");
          return !!(cartDrawer && cartDrawer.classList.contains("active"));
        };
        Object.defineProperty(window, 'location', {
          set: function(url) {
            if (window._preventCartReload || window._easifyAddToCartInProgress || isDrawerOpenForLocation()) {
              // Prevent navigation - just refresh cart
              const cartDrawer = document.getElementById("Cart-Drawer");
              if (cartDrawer) {
                document.body.classList.add("open-cc");
                cartDrawer.classList.add("active");
                if (typeof CartDrawer !== "undefined") {
                  const cartDrawerInstance = getCartDrawerInstance();
                  cartDrawerInstance.refresh();
                  cartDrawerInstance.hideQuantitySelectorForAddOns();
                }
              }
              return; // Prevent navigation
            }
            return originalLocationSetter.call(window, url);
          },
          get: locationDescriptor.get,
          configurable: true
        });
      }
      
      // Intercept window.location.assign (again here so we also refresh cart when blocking)
      const originalLocationAssignInner = window.location.assign;
      window.location.assign = function(url) {
        if (window._preventCartReload || window._easifyAddToCartInProgress || isDrawerOpenForLocation()) {
          const cartDrawer = document.getElementById("Cart-Drawer");
          if (cartDrawer) {
            document.body.classList.add("open-cc");
            cartDrawer.classList.add("active");
            if (typeof CartDrawer !== "undefined") {
              const cartDrawerInstance = getCartDrawerInstance();
              cartDrawerInstance.refresh();
              cartDrawerInstance.hideQuantitySelectorForAddOns();
            }
          }
          return; // Prevent navigation
        }
        return originalLocationAssignInner.apply(this, arguments);
      };
      
      // Intercept window.location.replace (again here so we also refresh cart when blocking)
      const originalLocationReplaceInner = window.location.replace;
      window.location.replace = function(url) {
        if (window._preventCartReload || window._easifyAddToCartInProgress || isDrawerOpenForLocation()) {
          const cartDrawer = document.getElementById("Cart-Drawer");
          if (cartDrawer) {
            document.body.classList.add("open-cc");
            cartDrawer.classList.add("active");
            if (typeof CartDrawer !== "undefined") {
              const cartDrawerInstance = getCartDrawerInstance();
              cartDrawerInstance.refresh();
              cartDrawerInstance.hideQuantitySelectorForAddOns();
            }
          }
          return; // Prevent navigation
        }
        return originalLocationReplaceInner.apply(this, arguments);
      };
    }
    
    // Also intercept beforeunload to prevent navigation
    window.addEventListener("beforeunload", function(e) {
      if (window._preventCartReload || window._easifyAddToCartInProgress) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    });
    
    // Intercept popstate to prevent navigation
    window.addEventListener("popstate", function(e) {
      if (window._easifyAddToCartInProgress) {
        e.preventDefault();
        history.pushState(null, null, window.location.href);
      }
    });
    
    // Monitor for any navigation attempts
    const originalPushState = history.pushState;
    history.pushState = function() {
      if (!window._easifyAddToCartInProgress) {
        return originalPushState.apply(history, arguments);
      }
    };
    
    const originalReplaceState = history.replaceState;
    history.replaceState = function() {
      if (!window._easifyAddToCartInProgress) {
        return originalReplaceState.apply(history, arguments);
      }
    };
    
    // Monitor for any network activity that might indicate cart update
    const networkObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        // Check for cart-related requests
        if (entry.name.includes("/cart") && (entry.name.includes("/add") || entry.name.includes("/update") || entry.name.includes("/change"))) {
          // Open drawer when any cart modification is detected
          setTimeout(() => {
            const cartDrawer = document.getElementById("Cart-Drawer");
            if (cartDrawer) {
              document.body.classList.add("open-cc");
              cartDrawer.classList.add("active");
              cartDrawer.focus();
              dispatchCustomEvent("cart-drawer:open");
              self.refresh();
              self.hideQuantitySelectorForAddOns();
            }
          }, 100);
        }
      }
    });

    networkObserver.observe({ entryTypes: ["resource"] });
    
    // Also monitor for any AJAX requests using XMLHttpRequest
    if (!window._originalXHROpen) {
      window._originalXHROpen = XMLHttpRequest.prototype.open;
    }
    const originalXHROpen = window._originalXHROpen;
    
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      if (typeof url === "string" && url.includes("/cart/add")) {
        // Open drawer when XHR request to add cart is detected
        this.addEventListener("load", function() {
          if (this.status >= 200 && this.status < 300) {
            setTimeout(() => {
              const cartDrawer = document.getElementById("Cart-Drawer");
              if (cartDrawer) {
                document.body.classList.add("open-cc");
                cartDrawer.classList.add("active");
                cartDrawer.focus();
                dispatchCustomEvent("cart-drawer:open");
                if (typeof CartDrawer !== "undefined") {
                  const cartDrawerInstance = getCartDrawerInstance();
                  cartDrawerInstance.refresh();
                  cartDrawerInstance.hideQuantitySelectorForAddOns();
                }
              }
            }, 150);
          }
        });
      }
      return originalXHROpen.apply(this, [method, url, ...rest]);
    };
  }

  onChange(event) {
    if (event.target.classList.contains("qty")) {
      const line = event.target.dataset.index;
      const quantity = event.target.value;
      if (parseInt(quantity, 10) === 0) {
        this.removeLineWithAddonIfMain(line);
      } else {
        this.updateQuantity(line, quantity);
      }
    }
  }

  /**
   * Returns true if the cart item element is an add-on.
   */
  isAddonItem(el) {
    return (
      el &&
      ((el.hasAttribute("data-is-addon") && el.getAttribute("data-is-addon") === "true") ||
        el.classList.contains("cart-item-addon"))
    );
  }

  /** When drawer HTML is re-rendered during removal, re-apply disabled state to View Bag link if removal still in progress. */
  _disableViewBagLinkIfRemoving() {
    if (!window._cartDrawerRemovalInProgress) return;
    const drawer = document.getElementById("Cart-Drawer");
    if (!drawer) return;
    const link = drawer.querySelector(".cart-drawer-view-bag-link") || drawer.querySelector(".cart-drawer-buttons a[href*='cart']");
    if (!link || link.closest("form")) return;
    const orig = link.getAttribute("data-original-href") || link.getAttribute("href") || "/cart";
    if (!link.getAttribute("data-original-href")) link.setAttribute("data-original-href", orig);
    link.setAttribute("href", "javascript:void(0)");
  }

  /**
   * @updated 26/03/2026
   * @updateDescription Remove a line. If it's a main product, also remove all associated add-ons. Add-on must never remain when its main product is removed.
   * Uses removeAssociatedAddOnsByKey (by line item key) so only this product and its add-ons are removed.
   * @author Updated by Renan Rodrigues
   */
  removeLineWithAddonIfMain(line) {
    const n = parseInt(line, 10);

    const drawerEl = document.getElementById("Cart-Drawer");

    const disableViewBagLink = () => {
      const drawer = document.getElementById("Cart-Drawer");
      if (!drawer) return;
      const link = drawer.querySelector(".cart-drawer-view-bag-link") || drawer.querySelector(".cart-drawer-buttons a[href*='cart']");
      if (!link || link.closest("form")) return;
      const orig = link.getAttribute("data-original-href") || link.getAttribute("href") || "/cart";
      if (!link.getAttribute("data-original-href")) link.setAttribute("data-original-href", orig);
      link.setAttribute("href", "javascript:void(0)");
    };

    const restoreViewBagLink = () => {
      const drawer = document.getElementById("Cart-Drawer");
      if (!drawer) return;
      const link = drawer.querySelector(".cart-drawer-view-bag-link") || drawer.querySelector(".cart-drawer-buttons a[href*='cart']");
      if (!link || link.closest("form")) return;
      const orig = link.getAttribute("data-original-href") || "/cart";
      link.setAttribute("href", orig);
    };

    const removeRemovingClass = () => {
      window._cartDrawerRemovalInProgress = false;
      if (drawerEl) drawerEl.classList.remove("cart-drawer-removing");
      restoreViewBagLink();
      // Re-evaluate checkout button (Grahams + any store using this path): re-enable when removal is done
      if (window.cartDrawerInstance && typeof window.cartDrawerInstance._updateCheckoutButtonRule1Blocked === "function") {
        window.cartDrawerInstance._updateCheckoutButtonRule1Blocked();
      }
    };

    if (drawerEl) drawerEl.classList.add("cart-drawer-removing");
    window._cartDrawerRemovalInProgress = true;
    disableViewBagLink();

    // ---------------------------
    // Shiels-only: removal flags + helpers
    // ---------------------------
    const isShiels = AppBehavior.isShiels;

    let clearRemovalFlag = () => {};
    let mainLineForRule4Clear = null;

    if (isShiels) {
      mainLineForRule4Clear = n;

      clearRemovalFlag = () => {
        window._cartDrawerRemovalInProgress = false;

        if (window._cartDrawerRule3PendingRemovalLine !== undefined) {
          window._cartDrawerRule3PendingRemovalLine = null;
        }

        if (window._cartDrawerRule4PendingRemovalLines && mainLineForRule4Clear >= 1) {
          window._cartDrawerRule4PendingRemovalLines.delete(mainLineForRule4Clear);
        }

        if (this._updateCheckoutButtonRule1Blocked) this._updateCheckoutButtonRule1Blocked();
        removeRemovingClass();
      };

      const singleItem = this._isSingleItemCart && this._isSingleItemCart();
      const twoMainPlusAddon = this._isTwoItemsMainPlusAddon && this._isTwoItemsMainPlusAddon();
      if (singleItem || twoMainPlusAddon) window._cartDrawerRemovalInProgress = true;
    }
    // ---------------------------

    if (!n || n < 1) {
      if (isShiels) {
        this.updateQuantity(line, "0").then(clearRemovalFlag).catch(clearRemovalFlag);
      } else {
        this.updateQuantity(line, "0").then(removeRemovingClass).catch(removeRemovingClass);
      }
      return;
    }

    const current = this.container.querySelector(`#CartDrawerItem-${n}`);

    if (!current) {
      if (isShiels) {
        this.updateQuantity(n, "0").then(clearRemovalFlag).catch(clearRemovalFlag);
      } else {
        this.updateQuantity(n, "0").then(removeRemovingClass).catch(removeRemovingClass);
      }
      return;
    }

    if (this.isAddonItem(current)) {
      if (isShiels) {
        this.updateQuantity(n, "0").then(clearRemovalFlag).catch(clearRemovalFlag);
      } else {
        this.updateQuantity(n, "0").then(removeRemovingClass).catch(removeRemovingClass);
      }
      return;
    }

    // Use clicked row's key when present; otherwise identify main by line (n) so add-ons are still found and removed first.
    const mainProductKey = current.getAttribute('data-cart-item-key') || '';

    if (!this.isAddonItem(current)) {
      this.getAddOnIndicesForMain(n).then((addOnIndices) => {
        (addOnIndices || []).forEach((lineNum) => {
          const row = this.container && this.container.querySelector(`#CartDrawerItem-${lineNum}`);
          if (row) row.setAttribute("data-removing", "true");
        });
      });
    }

    const chain = this.removeAssociatedAddOnsByKey(mainProductKey, n)
      .then((keyForMainRemoval) => {
        const keyToFind = (keyForMainRemoval != null && keyForMainRemoval !== '') ? keyForMainRemoval : mainProductKey;

        return fetch('/cart.js')
          .then(response => response.json())
          .then(updatedCartData => {
            if (!updatedCartData || !updatedCartData.items || updatedCartData.items.length === 0) return;
            const norm = (k) => (k == null ? '' : String(k).trim());
            let idx = keyToFind ? updatedCartData.items.findIndex(item => norm(item.key) === norm(keyToFind)) : -1;
            if (idx < 0 && keyToFind === '') idx = Math.max(0, n - 1);
            if (idx >= 0 && idx < updatedCartData.items.length) return this.updateQuantity(idx + 1, "0");
          })
          .catch(() => {});
      });

    if (isShiels) {
      chain.then(clearRemovalFlag).catch(clearRemovalFlag);
    } else {
      chain.then(removeRemovingClass).catch(removeRemovingClass);
    }
  }

  removeProductEvent() {
    // Ensure container exists
    if (!this.container) {
      console.warn('CartDrawer container not found in removeProductEvent');
      return;
    }
    
    // Use event delegation on the container instead of individual elements
    // This ensures it works even after DOM updates and avoids duplicate listeners
    // Remove any existing listener first to avoid duplicates
    if (this._removeProductHandler) {
      this.container.removeEventListener("click", this._removeProductHandler, true);
    }
    
    // Create a bound handler that we can remove later
    this._removeProductHandler = (event) => {
      // Check if the clicked element is a remove button or inside one
      // Check multiple levels up the DOM tree to find the remove button
      // This handles cases where SVG icons or other nested elements are clicked
      let removeButton = null;
      let currentElement = event.target;
      
      // Traverse up the DOM tree to find the remove button
      while (currentElement && currentElement !== this.container) {
        if (currentElement.classList && currentElement.classList.contains("remove")) {
          removeButton = currentElement;
          break;
        }
        currentElement = currentElement.parentElement;
      }
      
      // Fallback: try closest if traversal didn't work
      if (!removeButton) {
        removeButton = event.target.closest(".remove");
      }
      
      if (!removeButton) return;

      // Prevent default link behavior IMMEDIATELY to stop navigation
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Remove or disable href to prevent navigation
      const originalHref = removeButton.getAttribute("href");
      if (originalHref) {
        removeButton.setAttribute("data-original-href", originalHref);
        removeButton.removeAttribute("href");
        removeButton.style.cursor = "pointer";
      }

      const line = removeButton.getAttribute("data-index");
      if (!line) {
        // Try to get from original href if data-index is missing
        const href = originalHref || removeButton.getAttribute("data-original-href");
        if (href && href.includes("line=")) {
          const match = href.match(/line=(\d+)/);
          if (match) {
            const lineFromHref = match[1];
            this.removeLineWithAddonIfMain(lineFromHref);
            return;
          }
        }
        return;
      }

      // Capture product URL before removal for redirect after cart becomes empty
      const lineEl = this.container.querySelector(`#CartDrawerItem-${line}`);
      let productUrl = null;
      if (lineEl) {
        // First try to get from data-product-url attribute (most reliable)
        const dataProductUrl = lineEl.getAttribute('data-product-url');
        if (dataProductUrl) {
          productUrl = dataProductUrl;
        } else {
          // Fallback: try to get product URL from the product link
          const productLink = lineEl.querySelector('a.cart-product-link');
          if (productLink && productLink.href) {
            productUrl = productLink.href;
          } else {
            // Last fallback: construct from product handle
            const productHandle = lineEl.getAttribute('data-product-handle');
            if (productHandle) {
              productUrl = `/products/${productHandle}`;
            }
          }
        }
      }

      // Store product URL for later use
      this._removedProductUrl = productUrl;

      this.removeLineWithAddonIfMain(line);
    };
    
    // Add event listener to container using event delegation
    // Use capture phase (true) to ensure it runs before other handlers
    this.container.addEventListener("click", this._removeProductHandler, true);
  }
  
  /**
   * Get add-on line indices (1-based) for a main product at mainProductLine (1-based).
   * Returns a Promise that resolves to an array of line numbers.
   */
  getAddOnIndicesForMain(mainProductLine) {
    const mainIndex = parseInt(mainProductLine, 10) - 1;
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cartData) => {
        if (!cartData || !cartData.items || cartData.items.length === 0) return [];
        if (mainIndex < 0 || mainIndex >= cartData.items.length) return [];

        const mainItem = cartData.items[mainIndex];
        if (!mainItem) return [];

        const mainKey = mainItem.key ? String(mainItem.key) : null;
        const mainVariantId = mainItem.id ? String(mainItem.id).trim() : null;
        const variantMatch = (val) => val != null && mainVariantId && String(val).trim() === mainVariantId;
        const addOns = [];
        for (let i = 0; i < cartData.items.length; i++) {
          if (i === mainIndex) continue;
          const item = cartData.items[i];
          const keyMatch = mainKey && item.properties && item.properties._tpo_main_product_key && String(item.properties._tpo_main_product_key) === mainKey;
          if (keyMatch) {
            addOns.push(i + 1);
            continue;
          }
          if (i === mainIndex - 1 && item.properties && variantMatch(item.properties._tpo_main_product_id)) {
            addOns.push(i + 1);
            continue;
          }
          if (i === mainIndex + 1 && item.properties && variantMatch(item.properties._tpo_main_product_id) && item.properties._tpo_main_product_key && String(item.properties._tpo_main_product_key) === mainKey) {
            addOns.push(i + 1);
          }
        }
        return addOns;
      })
      .catch(() => []);
  }

  /**
   * @description Get add-on item keys (for removal by id after Save for later). Returns a Promise that resolves to an array of line item keys.
   * @author Renan Rodrigues
   */
  getAddOnKeysForMain(mainProductLine) {
    const mainIndex = parseInt(mainProductLine, 10) - 1;
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cartData) => {
        if (!cartData || !cartData.items || cartData.items.length === 0) return [];
        if (mainIndex < 0 || mainIndex >= cartData.items.length) return [];

        const mainItem = cartData.items[mainIndex];
        if (!mainItem) return [];

        const mainKey = mainItem.key ? String(mainItem.key) : null;
        const mainVariantId = mainItem.id ? String(mainItem.id).trim() : null;
        const variantMatch = (val) => val != null && mainVariantId && String(val).trim() === mainVariantId;
        const keys = [];
        for (let i = 0; i < cartData.items.length; i++) {
          if (i === mainIndex) continue;
          const item = cartData.items[i];
          if (item.key && mainKey && item.properties && item.properties._tpo_main_product_key && String(item.properties._tpo_main_product_key) === mainKey) {
            keys.push(item.key);
            continue;
          }
          if (item.key && i === mainIndex - 1 && item.properties && variantMatch(item.properties._tpo_main_product_id)) {
            keys.push(item.key);
            continue;
          }
          if (item.key && i === mainIndex + 1 && item.properties && variantMatch(item.properties._tpo_main_product_id) && item.properties._tpo_main_product_key && String(item.properties._tpo_main_product_key) === mainKey) {
            keys.push(item.key);
          }
        }
        return keys;
      })
      .catch(() => []);
  }

  /**
   * @description Remove add-ons associated with a main product identified by its line item key or line number.
   * Add-ons: _tpo_main_product_key === this main's key, OR item immediately ABOVE main with _tpo_main_product_id.
   * Never use item BELOW main (variant id) — that would wrongly remove another bundle's add-on when clicking a product without add-on.
   * @author Renan Rodrigues
   */
  removeAssociatedAddOnsByKey(mainProductKey, mainProductLine) {
    const mainKey = mainProductKey ? String(mainProductKey).trim() : '';
    const hasLine = mainProductLine != null && parseInt(mainProductLine, 10) >= 1;
    if (!mainKey && !hasLine) return Promise.resolve(mainKey);

    return new Promise((resolve, reject) => {
      if (!this.container) {
        reject(new Error('Container not found'));
        return;
      }

      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          if (!cartData || !cartData.items || cartData.items.length === 0) {
            resolve(mainKey);
            return;
          }

          const norm = (k) => (k == null ? '' : String(k).trim());
          let mainIndex = mainKey ? cartData.items.findIndex(item => norm(item.key) === mainKey) : -1;
          if (mainIndex < 0 && hasLine) {
            const lineIndex = parseInt(mainProductLine, 10) - 1;
            if (lineIndex >= 0 && lineIndex < cartData.items.length) mainIndex = lineIndex;
          }
          const mainItem = mainIndex >= 0 ? cartData.items[mainIndex] : null;
          const keyForMatch = mainItem && mainItem.key ? norm(mainItem.key) : mainKey;
          const mainVariantId = mainItem && mainItem.id ? String(mainItem.id).trim() : null;
          const variantMatch = (val) => val != null && mainVariantId && String(val).trim() === mainVariantId;

          // 1) Add-ons with _tpo_main_product_key === this main's key (any position).
          // 2) Item ABOVE main (mainIndex - 1) with _tpo_main_product_id === this main's variant id.
          // 3) Item BELOW main (mainIndex + 1) with _tpo_main_product_id AND _tpo_main_product_key === keyForMatch (so we never remove another bundle's add-on when clicking a product without add-on).
          const addOnsToRemove = [];
          for (let i = 0; i < cartData.items.length; i++) {
            const cartItem = cartData.items[i];
            if (norm(cartItem.key) === keyForMatch) continue;
            const keyMatch = keyForMatch && cartItem.properties && cartItem.properties._tpo_main_product_key && norm(cartItem.properties._tpo_main_product_key) === keyForMatch;
            if (keyMatch) {
              addOnsToRemove.push(i + 1);
              continue;
            }
            if (i === mainIndex - 1 && cartItem.properties && variantMatch(cartItem.properties._tpo_main_product_id)) {
              addOnsToRemove.push(i + 1);
              continue;
            }
            if (i === mainIndex + 1 && cartItem.properties && variantMatch(cartItem.properties._tpo_main_product_id) && norm(cartItem.properties._tpo_main_product_key) === keyForMatch) {
              addOnsToRemove.push(i + 1);
            }
          }

          if (addOnsToRemove.length === 0) {
            resolve(keyForMatch);
            return;
          }

          addOnsToRemove.sort((a, b) => b - a);
          let removeIndex = 0;
          const removeNext = () => {
            if (removeIndex >= addOnsToRemove.length) {
              resolve(keyForMatch);
              return;
            }
            const addOnIndex = addOnsToRemove[removeIndex];
            removeIndex++;
            this.updateQuantity(addOnIndex, "0")
              .then(removeNext)
              .catch(removeNext);
          };
          removeNext();
        })
        .catch(() => resolve(mainKey));
    });
  }
  
  /**
   * @description Check if an item is an add-on by examining its properties
   * @author Updated by Renan Rodrigues
   */
  isAddOnItem(item) {
    const productTitle = item.querySelector('.cart-product-link');
    const productTitleText = productTitle ? productTitle.textContent.toLowerCase().trim() : '';
    
    // Check if title contains "add-on", "addon", or "add on"
    if (productTitleText.includes('add-on') || 
        productTitleText.includes('addon') ||
        productTitleText.includes('add on')) {
      return true;
    }
    
    // Check properties for add-on indicators
    const properties = item.querySelectorAll('.product-cart-item-options');
    for (const prop of properties) {
      const propText = prop.textContent.toLowerCase();
      if (propText.includes('add-on') || 
          propText.includes('addon') ||
          propText.includes('add on') ||
          propText.includes('easify') ||
          propText.includes('bundle')) {
        return true;
      }
    }
    
    return false;
  }

  getSectionsToRender() {
    return [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const sectionElement = parsedHTML.querySelector(selector);
    
    if (!sectionElement) {
      return '';
    }
    
    // Remove strikethrough from main products BEFORE returning HTML
    // This ensures strikethrough never appears in the DOM, even if Liquid renders it
    // Check if this is cart-drawer content - be very permissive
    const hasCartItems = sectionElement.querySelectorAll('.product-cart-item').length > 0;
    const isCartDrawer = selector === '.cart-drawer' || 
                         selector === '.side-panel-content' || 
                         selector.includes('cart-drawer') || 
                         selector.includes('Cart-Drawer') ||
                         hasCartItems ||
                         sectionElement.querySelector('.product-cart-item--container') !== null ||
                         sectionElement.querySelector('#Cart-Drawer') !== null ||
                         sectionElement.classList.contains('cart-drawer') ||
                         sectionElement.id === 'Cart-Drawer';
    
    if (isCartDrawer) {
      const cartItems = sectionElement.querySelectorAll('.product-cart-item');
      cartItems.forEach(item => {
        // Check if this is an add-on - be very explicit
        const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
        const hasClass = item.classList.contains('cart-item-addon');
        
        const isAddOn = hasDataAttr || hasClass;
        
        if (!isAddOn) {
          // This is a MAIN PRODUCT - remove ALL del elements before inserting into DOM
          const allDelElements = item.querySelectorAll('del');
          allDelElements.forEach(delEl => {
            // Remove the del element completely
            if (delEl.parentNode) {
              delEl.parentNode.removeChild(delEl);
            }
          });
        }
        // If it's an add-on, DO NOT remove del elements - they should show strikethrough when they have discount
      });
    }
    
    return sectionElement.innerHTML;
  }

  termsCheckbox() {
    let terms_checkbox = this.container.querySelector("#CartDrawerTerms"),
      checkout_button = this.container.querySelector(".button.checkout");

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener("click", function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }

  notesToggle() {
    let notes_toggle = document.getElementById("order-note-toggle");

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener("click", (event) => {
      notes_toggle.nextElementSibling.classList.add("active");
    });
    notes_toggle.nextElementSibling.querySelectorAll(".button, .order-note-toggle__content-overlay").forEach((el) => {
      el.addEventListener("click", (event) => {
        notes_toggle.nextElementSibling.classList.remove("active");
        this.saveNotes();
      });
    });
  }

  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        note: document.getElementById("mini-cart__notes").value,
      }),
    });
  }
  
  updateQuantity(line, quantity) {
    const lineEl = this.container && this.container.querySelector(`#CartDrawerItem-${line}`);
    if (lineEl) lineEl.classList.add("thb-loading");
    // Prevent full-page reload/redirect while updating quantity (e.g. from third-party scripts)
    window._preventCartReload = true;
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    dispatchCustomEvent("line-item:change:start", {
      quantity: quantity,
    });
    return fetch(`${theme.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (!elementToReplace || !parsedState.sections) {
            return;
          }

          // Update content normally with error handling
          try {
            const newHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            elementToReplace.innerHTML = newHTML;
          } catch (e) {
            console.warn(`Error updating ${section.section} content in updateQuantity:`, e);
          }
          
          // Remove strikethrough from main products IMMEDIATELY after innerHTML update (no delay) to prevent flickering
          // This must happen synchronously before any other code runs
          // Also ensure quantity selector is visible for main products
          if (section.section === 'cart-drawer') {
            if (window._cartDrawerRemovalInProgress) {
              const d = document.getElementById("Cart-Drawer");
              if (d) d.classList.add("cart-drawer-removing");
              if (typeof this._disableViewBagLinkIfRemoving === "function") this._disableViewBagLinkIfRemoving();
            }
            if ((AppBehavior.isShiels || AppBehavior.isGrahams || AppBehavior.isWatchdepot) && this._updateCheckoutButtonRule1Blocked) {
              this._updateCheckoutButtonRule1Blocked();
            }

            // Remove strikethrough from main products immediately - synchronous - MULTIPLE TIMES
            this.removeStrikethroughFromMainProducts();
            this.hideQuantitySelectorForAddOns();
            this.hideQuantitySelectorForAddOns();
            
            // Also use requestAnimationFrame for immediate execution
            requestAnimationFrame(() => {
              this.removeStrikethroughFromMainProducts();
              this.hideQuantitySelectorForAddOns();
              this.hideQuantitySelectorForAddOns();
            });
            
            // Also call with 0 delay for immediate execution
            setTimeout(() => {
              this.removeStrikethroughFromMainProducts();
              this.hideQuantitySelectorForAddOns();
              this.hideQuantitySelectorForAddOns();
            }, 0);
            
            // Additional call after a short delay to catch any late rendering
            setTimeout(() => {
              this.removeStrikethroughFromMainProducts();
              this.hideQuantitySelectorForAddOns();
            }, 10);
            
            setTimeout(() => {
              this.removeStrikethroughFromMainProducts();
              this.hideQuantitySelectorForAddOns();
            }, 50);
          }
        });
        
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
        
        // Scenario 2 Item 3: When main product quantity changes, sync associated add-on quantities
        if (quantity !== "0" && quantity !== 0 && !this._syncingAddOnQuantity) {
          this.getAddOnIndicesForMain(line).then((addOnIndices) => {
            if (addOnIndices.length === 0) return;
            this._syncingAddOnQuantity = true;
            let i = 0;
            const syncNext = () => {
              if (i >= addOnIndices.length) {
                this._syncingAddOnQuantity = false;
                return;
              }
              const addOnLine = addOnIndices[i];
              const addOnBody = JSON.stringify({
                line: addOnLine,
                quantity,
                sections: this.getSectionsToRender().map((s) => s.section),
                sections_url: window.location.pathname,
              });
              fetch(`${theme.routes.cart_change_url}`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: addOnBody,
              })
                .then((res) => res.text())
                .then((state) => {
                  try {
                    const parsed = JSON.parse(state);
                    if (parsed.sections) {
                      this.getSectionsToRender().forEach((section) => {
                        const el = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                        if (el && parsed.sections[section.section]) {
                          try {
                            el.innerHTML = this.getSectionInnerHTML(parsed.sections[section.section], section.selector);
                          } catch (e) {}
                        }
                      });
                      this.removeProductEvent();
                      this.hideQuantitySelectorForAddOns();
                      this.removeStrikethroughFromMainProducts();
                      this.disableAddOnLinks();
                      this.styleSwymSaveForLaterLinks();
                    }
                  } catch (e) {}
                  i++;
                  syncNext();
                })
                .catch(() => {
                  i++;
                  syncNext();
                });
            };
            syncNext();
          });
        }
        
        // Check if cart is empty after removal and redirect to product page
        // Check both parsedState.item_count and sections.cart-drawer to determine if cart is empty
        let isCartEmpty = false;
        
        if (parsedState && parsedState.item_count !== undefined) {
          isCartEmpty = parsedState.item_count === 0;
        } else if (parsedState && parsedState.sections && parsedState.sections['cart-drawer']) {
          // Check if the cart drawer HTML shows empty cart message
          const drawerHTML = parsedState.sections['cart-drawer'];
          if (drawerHTML.includes('cart-drawer__empty-cart') || drawerHTML.includes('cart_empty')) {
            isCartEmpty = true;
          }
        }
        
        if (isCartEmpty) {
          this._removedProductUrl = null;
          // Close drawer and stay on current page (do not redirect to removed product page)
          setTimeout(() => {
            if (this.container) {
              this.container.classList.remove("active");
              document.body.classList.remove("open-cc");
            }
          }, 300);
          if (this.container) {
            const el = this.container.querySelector(`#CartDrawerItem-${line}`);
            if (el) el.classList.remove("thb-loading");
          }
          return parsedState;
        }

        this._removedProductUrl = null;
        
        dispatchCustomEvent("line-item:change:end", {
          quantity: quantity,
          cart: parsedState,
        });
        if (this.container && this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove("thb-loading");
        }
      })
      .catch((err) => {
        if (this.container && this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove("thb-loading");
        }
        throw err;
      })
      .finally(() => {
        window._preventCartReload = false;
      });
  }

  refresh() {
    const now = Date.now();
    // Prevent too frequent refreshes (minimum 100ms between refreshes)
    if (now - this.lastRefreshTime < 100) {
      return;
    }
    this.lastRefreshTime = now;

    // Store drawer state before refresh to ensure it stays open
    const wasDrawerOpen = this.container && this.container.classList.contains("active");
    const wasBodyOpen = document.body.classList.contains("open-cc");

    let sections = "cart-drawer,cart-bubble";
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        // Note: createElement is already intercepted globally at the top of the file
        // This ensures SearchSpring errors are prevented everywhere, including during cart refresh

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (!elementToReplace) {
            return;
          }

          // Apply add-on strikethrough BEFORE updating innerHTML to prevent flickering
          // This ensures add-ons are hidden immediately, before any visual update
          if (section.section === 'cart-drawer') {
            // Store SearchSpring recommendations script and container before updating
            const recommendationsScript = elementToReplace.querySelector('script[type="searchspring/recommendations"]');
            const recommendationsContainer = elementToReplace.querySelector('.ss__recs__side-cart');
            let recommendationsScriptContent = null;
            let recommendationsContent = null;
            
            if (recommendationsScript) {
              recommendationsScriptContent = recommendationsScript.outerHTML;
            }
            if (recommendationsContainer) {
              recommendationsContent = recommendationsContainer.outerHTML;
            }

            // Preserve optimistic quantity values before replace (fixes 1→2 flicker when refresh completes after user clicked +)
            const currentQtyInputs = elementToReplace.querySelectorAll('input[name="updates[]"]');
            const optimisticQuantitiesByLine = {};
            currentQtyInputs.forEach((input) => {
              const line = input.getAttribute('data-index');
              if (line) {
                const val = parseInt(input.value, 10);
                if (!isNaN(val)) optimisticQuantitiesByLine[line] = val;
              }
            });

            // Update the content
            const newHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
            elementToReplace.innerHTML = newHTML;

            // Re-apply optimistic quantities so a late refresh() doesn't overwrite 2 with 1 (only when current was higher)
            Object.keys(optimisticQuantitiesByLine).forEach((line) => {
              const optimisticQty = optimisticQuantitiesByLine[line];
              const newInput = elementToReplace.querySelector(`input[name="updates[]"][data-index="${line}"]`);
              if (newInput) {
                const newQty = parseInt(newInput.value, 10) || parseInt(newInput.getAttribute('value'), 10) || 0;
                if (optimisticQty > newQty) {
                  newInput.value = optimisticQty;
                  newInput.setAttribute('value', optimisticQty);
                }
              }
            });
            
            // Remove strikethrough from main products IMMEDIATELY after innerHTML update
            // Also ensure quantity selector is visible
            if (section.section === 'cart-drawer') {
              if (window._cartDrawerRemovalInProgress) {
                const d = document.getElementById("Cart-Drawer");
                if (d) d.classList.add("cart-drawer-removing");
                if (typeof this._disableViewBagLinkIfRemoving === "function") this._disableViewBagLinkIfRemoving();
              }
              // Call immediately - synchronous - MULTIPLE TIMES to ensure it works
              this.removeStrikethroughFromMainProducts();
              this.hideQuantitySelectorForAddOns();
              
              // Also call in next frame to catch any delayed rendering
              requestAnimationFrame(() => {
                this.removeStrikethroughFromMainProducts();
                this.hideQuantitySelectorForAddOns();
              });
              
              // Also call with setTimeout 0
              setTimeout(() => {
                this.removeStrikethroughFromMainProducts();
                this.hideQuantitySelectorForAddOns();
              }, 0);
              
              // Additional call after short delay
              setTimeout(() => {
                this.removeStrikethroughFromMainProducts();
                this.hideQuantitySelectorForAddOns();
              }, 10);
            }

            // Restore SearchSpring recommendations script and container if they existed
            if (recommendationsScriptContent) {
              // Find where to insert (before the closing of product-cart-item--container or before empty cart message)
              const productContainer = elementToReplace.querySelector('.product-cart-item--container');
              const emptyCart = elementToReplace.querySelector('.cart-drawer__empty-cart');
              const insertPoint = productContainer ? productContainer.nextElementSibling : (emptyCart ? emptyCart : null);
              
              if (insertPoint) {
                insertPoint.insertAdjacentHTML('beforebegin', recommendationsScriptContent);
              } else if (productContainer) {
                productContainer.insertAdjacentHTML('afterend', recommendationsScriptContent);
              }
            }
            
            if (recommendationsContent) {
              const newRecommendationsContainer = elementToReplace.querySelector('.ss__recs__side-cart');
              if (newRecommendationsContainer) {
                newRecommendationsContainer.outerHTML = recommendationsContent;
              } else {
                // If container doesn't exist, add it
                const productContainer = elementToReplace.querySelector('.product-cart-item--container');
                if (productContainer) {
                  productContainer.insertAdjacentHTML('afterend', recommendationsContent);
                }
              }
            }
          } else {
            // For other sections, update normally
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
            
            // Remove strikethrough from main products for cart-drawer even in else branch
            if (section.section === 'cart-drawer') {
              this.removeStrikethroughFromMainProducts();
            }
          }

          // This line was in the file already, but Search Spring added it above in his else flow. I will keep it commented out here.
          // elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        });

        // Note: createElement is already globally intercepted, no need to restore

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
        // Sync header cart count (My Bag) after section replace so both mobile and desktop badges show correct count
        this.updateCartCounter();
      });
  }
  
  /**
   * Listen for cart drawer open events to ensure add-ons display correctly
   */
  setupCartDrawerOpenListener() {
    document.addEventListener("cart-drawer:open", () => {
      // Call immediately and with delays to catch all rendering stages
      requestAnimationFrame(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      });
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 10);
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 50);
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 150);
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 300);
    });
  }

  updateCartCounter() {
    const now = Date.now();

    if (this._cartCounterFetchPromise) {
      return this._cartCounterFetchPromise;
    }

    if (now - this._cartCounterLastFetchAt < 300) {
      return Promise.resolve();
    }

    this._cartCounterLastFetchAt = now;

    var cartUrl = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_url) ? theme.routes.cart_url : '/cart';
    var url = (cartUrl.indexOf('.js') === -1) ? cartUrl + '.js' : cartUrl;

    this._cartCounterFetchPromise = fetch(url)
      .then((response) => {
        if (!response.ok) {
          if (response.status >= 500) return Promise.reject(new Error('Server error: ' + response.status));
          throw new Error('HTTP error: ' + response.status);
        }
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') === -1) {
          return Promise.reject(new Error('Cart response not JSON'));
        }
        return response.json();
      })
      .then((cart) => {
        if (!cart || typeof cart !== 'object') return;
        var count = cart.item_count || 0;
        if (!this._cartCountElements) {
          this._cartCountElements = [];
          document.querySelectorAll('.thb-item-count').forEach((el) => {
            const id = el.getAttribute('id') || '';
            if (id !== 'wishlist-item-count' && id !== 'wishlist-item-count-desktop') {
              this._cartCountElements.push(el);
            }
          });
        }

        const cartCountElements = this._cartCountElements;
        cartCountElements.forEach(function(element) {
          if (count > 99) {
            element.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
          } else {
            element.textContent = count;
          }
          element.style.display = 'flex';
        });
      })
      .catch(function(error) {
        if (error && error.message && error.message.indexOf('Cart response not JSON') !== -1) return;
        console.error('Error updating cart counter:', error);
      })
      .finally(() => {
        this._cartCounterFetchPromise = null;
      });

    return this._cartCounterFetchPromise;
  }
  
  /**
   * Listen for cart drawer open events to ensure add-ons display correctly
   */
  setupCartDrawerOpenListener() {
    document.addEventListener("cart-drawer:open", () => {
      // Call immediately and with delays to catch all rendering stages
      requestAnimationFrame(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      });
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 10);
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 50);
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 150);
      setTimeout(() => {
        this.hideQuantitySelectorForAddOns();
        this.removeStrikethroughFromMainProducts();
        this.disableAddOnLinks();
        this.styleSwymSaveForLaterLinks();
      }, 300);
    });
  }

  /**
   * @description Hide quantity selector and remove button for add-on items in the cart drawer, and show a horizontal line instead.
   * @author Renan Rodrigues
   */
  hideQuantitySelectorForAddOns() {
    if (!this.container) return;
    
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on - be very explicit and check multiple ways
      const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
      const hasClass = item.classList.contains('cart-item-addon');
      
      // Also check product title as fallback
      const productLink = item.querySelector('.cart-product-link');
      const productTitle = productLink ? productLink.textContent.toLowerCase().trim() : '';
      // IMPORTANT: Do NOT treat "chain" in a title as an add-on marker.
      // const titleIsAddOn = productTitle.includes('add-on') || productTitle.includes('addon');
      const isAddOn = hasDataAttr || hasClass;
      
      if (isAddOn) {
        // Hide quantity selector and remove button
        const quantitySelector = item.querySelector('quantity-selector');
        if (quantitySelector) {
          quantitySelector.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important;';
        }
        const removeButton = item.querySelector('.remove');
        if (removeButton) {
          removeButton.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
        }
        // Show horizontal line
        let horizontalLine = item.querySelector('.addon-quantity-line');
        if (!horizontalLine) {
          horizontalLine = document.createElement('div');
          horizontalLine.className = 'addon-quantity-line';
          const flexContainer = item.querySelector('.flex.items-center');
          if (flexContainer) {
            flexContainer.insertBefore(horizontalLine, flexContainer.firstChild);
          }
        }
        horizontalLine.style.cssText = 'width: 100%; height: 2px; background-color: #000; margin: 8px 0; display: block !important; visibility: visible !important; opacity: 1 !important;';
      } else {
        // This is a MAIN PRODUCT - remove strikethrough and show quantity selector
        const horizontalLines = item.querySelectorAll('.addon-quantity-line');
        horizontalLines.forEach(line => line.remove());
        
        // Ensure quantity selector is visible and functional for main products
        const quantitySelector = item.querySelector('quantity-selector');
        if (quantitySelector) {
          quantitySelector.style.cssText = '';
          quantitySelector.style.display = 'inline-flex';
          quantitySelector.style.visibility = 'visible';
          quantitySelector.style.opacity = '1';
        }
        
        // Ensure remove button is visible for main products
        const removeButton = item.querySelector('.remove');
        if (removeButton) {
          removeButton.style.cssText = '';
          removeButton.style.display = '';
          removeButton.style.visibility = 'visible';
          removeButton.style.opacity = '1';
        }
        
        // Remove strikethrough (del elements) from main products ONLY
        // This is a main product, so remove ALL del elements
        const allDelElements = item.querySelectorAll('del');
        allDelElements.forEach(delEl => {
          delEl.remove();
        });
      }
    });
  }

  /**
   * @description Remove strikethrough (del elements) from main products ONLY. Add-ons MUST keep their strikethrough when they have discount.
   * This function is called aggressively to ensure strikethrough is always removed from main products. Also ensures quantity selector is visible for main products.
   * @author Renan Rodrigues
   */
  removeStrikethroughFromMainProducts() {
    if (!this.container) return;
    
    // Get all cart items
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on - be very explicit and check multiple ways
      const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
      const hasClass = item.classList.contains('cart-item-addon');
      
      // Also check product title as fallback
      const productLink = item.querySelector('.cart-product-link');
      const productTitle = productLink ? productLink.textContent.toLowerCase().trim() : '';
      // IMPORTANT: Do NOT treat "chain" in a title as an add-on marker.
      // const titleIsAddOn = productTitle.includes('add-on') || productTitle.includes('addon');
      const isAddOn = hasDataAttr || hasClass;
      
      if (isAddOn) {
        // This is an add-on - DO NOT REMOVE strikethrough, keep it visible
        // Add-ons should show strikethrough when they have discount
        // DO NOT TOUCH add-ons - skip completely
        return; // Skip this item completely - don't process add-ons
      }
      
      // This is a MAIN PRODUCT - process it
      // Remove ALL strikethrough elements from main products immediately
      const allDelElements = item.querySelectorAll('del');
      allDelElements.forEach(delEl => {
        // Remove immediately
        if (delEl.parentNode) {
          delEl.parentNode.removeChild(delEl);
        } else {
          delEl.remove();
        }
      });
      
      // Also apply CSS to hide any del elements that might appear (double protection)
      const remainingDelElements = item.querySelectorAll('del');
      remainingDelElements.forEach(delEl => {
        delEl.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; width: 0 !important; margin: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important; overflow: hidden !important; position: absolute !important; clip: rect(0, 0, 0, 0) !important; pointer-events: none !important;';
        // Also try to remove again
        setTimeout(() => {
          if (delEl.parentNode) {
            delEl.parentNode.removeChild(delEl);
          }
        }, 0);
      });
      
      // Ensure quantity selector is visible and functional for main products
      const quantitySelector = item.querySelector('quantity-selector');
      if (quantitySelector) {
        // Remove any inline styles that might hide it
        quantitySelector.style.cssText = '';
        quantitySelector.style.display = 'inline-flex';
        quantitySelector.style.visibility = 'visible';
        quantitySelector.style.opacity = '1';
        quantitySelector.style.height = 'auto';
        quantitySelector.style.width = 'auto';
        quantitySelector.style.margin = '';
        quantitySelector.style.padding = '';
      }
      
      // Also ensure remove button is visible for main products
      const removeButton = item.querySelector('.remove');
      if (removeButton) {
        removeButton.style.cssText = '';
        removeButton.style.display = '';
        removeButton.style.visibility = 'visible';
        removeButton.style.opacity = '1';
      }
    });
  }
  
  /**
   * @description Disable add-on product links - make them non-clickable (plain text only). This ensures add-on chains are not clickable in the cart drawer
   * @author Renan Rodrigues
   */
  disableAddOnLinks() {
    if (!this.container) return;
    
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on - be very explicit and check multiple ways
      const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
      const hasClass = item.classList.contains('cart-item-addon');
      
      // Also check product title as fallback
      const productLink = item.querySelector('.cart-product-link');
      const productTitle = productLink ? productLink.textContent.toLowerCase().trim() : '';
      // IMPORTANT: Do NOT treat "chain" in a title as an add-on marker.
      // const titleIsAddOn = productTitle.includes('add-on') || productTitle.includes('addon');
      const isAddOn = hasDataAttr || hasClass;
      
      if (isAddOn) {
        // This is an add-on - disable all links
        const links = item.querySelectorAll('a.cart-product-link');

        links.forEach(link => {
          // Remove href attribute
          link.removeAttribute('href');
          // Apply styles to disable pointer events
          link.style.cssText = 'cursor: default !important; pointer-events: none !important; text-decoration: none !important;';
          
          // Prevent click events
          if (!link._addonLinkClickBound) {
            link._addonLinkClickBound = true;

            link.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }, true);
          }
        });
      }
    });
  }

  /**
   * @description Start continuous monitoring to remove strikethrough from main products. This runs while the drawer is open.
   * 
   * @updated 27/03/2026
   * @updateDescription Replace setInterval from 50 to 200ms to reduce CPU usage while maintaining good user experience. 
   * The function is called immediately multiple times to ensure strikethrough is removed without delay when the drawer opens, and then continues to run every 200ms while the drawer is open to catch any late-rendered elements. 
   * @author Updated by Renan Rodrigues
   */
  startStrikethroughRemovalMonitor() {
    if (!this.container) return;
    
    // Clear any existing interval
    if (this._strikethroughRemovalInterval) {
      clearInterval(this._strikethroughRemovalInterval);
    }
    
    // Run immediately - multiple times to ensure it works
    this.removeStrikethroughFromMainProducts();
    this.hideQuantitySelectorForAddOns();
    
    // Run continuously every 50ms while drawer is open (more frequent)
    this._strikethroughRemovalInterval = setInterval(() => {
      if (this.container && this.container.classList.contains('active')) {
        this.removeStrikethroughFromMainProducts();
        this.hideQuantitySelectorForAddOns();
      } else {
        // Drawer closed, stop monitoring
        if (this._strikethroughRemovalInterval) {
          clearInterval(this._strikethroughRemovalInterval);
          this._strikethroughRemovalInterval = null;
        }
      }
    }, 200); // => It was 50
  }
  
  /**
   * Stop continuous monitoring
   */
  stopStrikethroughRemovalMonitor() {
    if (this._strikethroughRemovalInterval) {
      clearInterval(this._strikethroughRemovalInterval);
      this._strikethroughRemovalInterval = null;
    }
  }

  /**
   * Style Swym Save for later links - no underline, larger font, and ensure they work as links
   * This function works for both regular products and add-ons (even when strikethrough is visible)
   */
  styleSwymSaveForLaterLinks() {
    if (!this.container) return;
    if (this.container.getAttribute('data-save-later-ui') === 'disabled') return;

    // Set up MutationObserver to remove duplicates and add-on Save for later
    if (!this.container.hasAttribute('data-save-later-observer')) {
      this.container.setAttribute('data-save-later-observer', 'true');
      const observer = new MutationObserver(() => {
        this.removeSaveForLaterFromAddOns();
      });
      observer.observe(this.container, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    
    this.removeSaveForLaterFromAddOns();
    this.removeDuplicateSaveForLaterInDrawer();

    // Save for later in drawer: same concept as trash — find add-ons via API (getAddOnKeysForMain, like removeLineWithAddonIfMain) then remove add-ons + main, then Swym + refresh
    if (!this.container.hasAttribute('data-save-later-remove-delegation')) {
      this.container.setAttribute('data-save-later-remove-delegation', 'true');
      this.container.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="save-for-later"], .swym-save-for-later, .swym-button[data-swaction="saveForLater"]');
        if (!link || !this.container.contains(link)) return;
        const cartItem = link.closest('.product-cart-item');
        if (!cartItem) return;
        const isAddOn = (cartItem.hasAttribute('data-is-addon') && cartItem.getAttribute('data-is-addon') === 'true') || cartItem.classList.contains('cart-item-addon');
        if (isAddOn) return;
        const quantitySelector = cartItem.querySelector('quantity-selector');
        const mainKey = quantitySelector ? quantitySelector.getAttribute('data-id') : null;
        if (!mainKey) return;
        e.preventDefault();
        e.stopPropagation();
        const mainLine = parseInt(cartItem.getAttribute('id')?.replace('CartDrawerItem-', '') || '0', 10);
        const keysFromDom = this.getAddOnKeysFromDom(cartItem);
        this.getAddOnKeysForMain(mainLine).then((keysFromApi) => {
          const keysToRemove = (keysFromApi && keysFromApi.length > 0) ? keysFromApi : keysFromDom;
          const removals = keysToRemove.map((k) => ({ id: k, quantity: 0 })).concat(mainKey ? [{ id: mainKey, quantity: 0 }] : []);
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              const item = cart.items && cart.items.find((i) => i.key === mainKey);
              let productData = null;
              if (item) {
                const baseUrl = window.location.origin;
                const du = (item.url && item.url.startsWith('http')) ? item.url : baseUrl + (item.url ? (item.url.startsWith('/') ? item.url : '/' + item.url) : '');
                const iu = (item.image && item.image.startsWith('http')) ? item.image : (item.image ? baseUrl + (item.image.startsWith('/') ? item.image : '/' + item.image) : '');
                productData = { epi: String(item.id || ''), empi: String(item.product_id || ''), du, dt: item.product_title || item.title || '', iu, pr: (item.price || 0) / 100 };
              }
              let idx = 0;
              const removeNext = () => {
                if (idx >= removals.length) {
                  if (productData && typeof _swat !== 'undefined' && _swat.saveForLater) {
                    try { _swat.saveForLater(productData); if (_swat.refresh) _swat.refresh(); } catch (err) {}
                  }
                  if (typeof this.refresh === 'function') this.refresh();
                  return;
                }
                fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(removals[idx]) })
                  .then(() => { idx++; setTimeout(removeNext, 200); })
                  .catch(() => { idx++; setTimeout(removeNext, 200); });
              };
              removeNext();
            })
            .catch(() => {
              let idx = 0;
              const removeNext = () => {
                if (idx >= removals.length) {
                  if (typeof this.refresh === 'function') this.refresh();
                  return;
                }
                fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(removals[idx]) })
                  .then(() => { idx++; setTimeout(removeNext, 200); })
                  .catch(() => { idx++; setTimeout(removeNext, 200); });
              };
              removeNext();
            });
        });
      }, true);
    }
  }

  /**
   * @description Get add-on item keys from DOM: product-cart-item rows with data-is-addon immediately before/after main (same as cart page).
   * @author Renan Rodrigues
   */
  getAddOnKeysFromDom(mainCartItem) {
    if (!this.container || !mainCartItem) return [];
    const items = Array.from(this.container.querySelectorAll('.product-cart-item'));
    const idx = items.indexOf(mainCartItem);
    if (idx < 0) return [];
    const isAddOnEl = (el) => (el.hasAttribute('data-is-addon') && el.getAttribute('data-is-addon') === 'true') || el.classList.contains('cart-item-addon');
    const getKey = (el) => el.querySelector('quantity-selector')?.getAttribute('data-id') || null;
    const keys = [];
    for (let i = idx - 1; i >= 0 && isAddOnEl(items[i]); i--) {
      const k = getKey(items[i]);
      if (k) keys.push(k);
    }
    for (let j = idx + 1; j < items.length && isAddOnEl(items[j]); j++) {
      const k = getKey(items[j]);
      if (k) keys.push(k);
    }
    return keys;
  }

  /**
   * @description Remove "Save for later" text from add-ons ONLY
   * @author Renan Rodrigues
   */
  removeSaveForLaterFromAddOns() {
    if (!this.container) return;
    if (this.container.getAttribute('data-save-later-ui') === 'disabled') return;

    // Find ONLY add-ons
    const addOnItems = this.container.querySelectorAll('.product-cart-item[data-is-addon="true"], .product-cart-item.cart-item-addon');
    
    addOnItems.forEach(item => {
      // Verify it's really an add-on
      const isAddOn = (item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true') ||
                     item.classList.contains('cart-item-addon');
      
      if (!isAddOn) return; // Skip if not add-on
      
      // Remove text nodes containing "Save for later"
      const walker = document.createTreeWalker(
        item,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      
      let textNode;
      while (textNode = walker.nextNode()) {
        const text = textNode.textContent.trim();
        if (text === 'Save for later' || text === 'save for later') {
          const parent = textNode.parentNode;
          if (parent) {
            try {
              parent.removeChild(textNode);
              // Clean up empty parent
              if (parent.textContent.trim() === '' && parent.children.length === 0 && 
                  parent.tagName !== 'SCRIPT' && parent.tagName !== 'STYLE') {
                parent.remove();
              }
            } catch (e) {
              // Replace with empty text
              textNode.textContent = '';
            }
          }
        }
      }
      
      // Remove elements that contain ONLY "Save for later"
      const allElements = item.querySelectorAll('*');
      allElements.forEach(element => {
        const text = element.textContent?.trim() || '';
        if (text === 'Save for later' || text === 'save for later') {
          try {
            element.remove();
          } catch (e) {
            element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important;';
          }
        }
      });
      
      // Remove all Swym links/buttons from add-ons
      const swymElements = item.querySelectorAll(
        '.swym-save-for-later, ' +
        'a[href*="save-for-later"], ' +
        '.swym-button[data-swaction="saveForLater"], ' +
        'a.swym-save-for-later, ' +
        '[class*="swym"][class*="save"]'
      );
      
      swymElements.forEach(element => {
        const text = element.textContent?.trim() || '';
        if (text.includes('Save for later') || text.includes('save for later')) {
          try {
            element.remove();
          } catch (e) {
            element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; font-size: 0 !important;';
          }
        }
      });
    });
  }
  
  /**
   * @description Remove duplicate "Save for later" per product (Scenario 1 & 2 Item 4). Keep only one link per main product; add-ons already handled by removeSaveForLaterFromAddOns.
   * @author Renan Rodrigues
   */
  removeDuplicateSaveForLaterInDrawer() {
    if (!this.container) return;
    const mainItems = this.container.querySelectorAll('.product-cart-item:not([data-is-addon="true"]):not(.cart-item-addon)');
    mainItems.forEach(item => {
      const links = item.querySelectorAll('a[href*="save-for-later"], .swym-save-for-later, .swym-button[data-swaction="saveForLater"], [class*="swym"][class*="save"]');
      if (links.length <= 1) return;
      for (let i = 1; i < links.length; i++) {
        try { links[i].remove(); } catch (e) { links[i].style.cssText = 'display:none!important'; }
      }
    });
  }

  /**
   * @description Hide quantity selector and remove button for add-ons, show horizontal line immediately. Also remove strikethrough from main products.
   * @author Renan Rodrigues
   */
  hideQuantitySelectorForAddOns() {
    if (!this.container) return;
    
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on - be very explicit and check multiple ways
      const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
      const hasClass = item.classList.contains('cart-item-addon');
      
      // Also check product title as fallback
      const productLink = item.querySelector('.cart-product-link');
      const productTitle = productLink ? productLink.textContent.toLowerCase().trim() : '';
      // Fallback: title contains "add-on"/"addon" only. Primary addon detection is data-is-addon from Liquid (Easify _tpo_main_*).
      // const titleIsAddOn = productTitle.includes('add-on') || productTitle.includes('addon');
      const isAddOn = hasDataAttr || hasClass;
      
      if (isAddOn) {
        // Hide quantity selector and remove button
        const quantitySelector = item.querySelector('quantity-selector');
        if (quantitySelector) {
          quantitySelector.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important;';
        }
        const removeButton = item.querySelector('.remove');
        if (removeButton) {
          removeButton.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
        }
        // Show horizontal line
        let horizontalLine = item.querySelector('.addon-quantity-line');
        if (!horizontalLine) {
          horizontalLine = document.createElement('div');
          horizontalLine.className = 'addon-quantity-line';
          const flexContainer = item.querySelector('.flex.items-center');
          if (flexContainer) {
            flexContainer.insertBefore(horizontalLine, flexContainer.firstChild);
          }
        }
        horizontalLine.style.cssText = 'width: 100%; height: 2px; background-color: #000; margin: 8px 0; display: block !important; visibility: visible !important; opacity: 1 !important;';
      } else {
        // This is a MAIN PRODUCT - remove strikethrough and show quantity selector
        const horizontalLines = item.querySelectorAll('.addon-quantity-line');
        horizontalLines.forEach(line => line.remove());
        
        // CRITICAL: Ensure quantity selector is visible and functional for main products
        const quantitySelector = item.querySelector('quantity-selector');
        if (quantitySelector) {
          quantitySelector.style.cssText = '';
          quantitySelector.style.display = 'inline-flex';
          quantitySelector.style.visibility = 'visible';
          quantitySelector.style.opacity = '1';
        }
        
        // CRITICAL: Ensure remove button is visible for main products
        const removeButton = item.querySelector('.remove');
        if (removeButton) {
          removeButton.style.cssText = '';
          removeButton.style.display = '';
          removeButton.style.visibility = 'visible';
          removeButton.style.opacity = '1';
        }
        
        // CRITICAL: Remove strikethrough (del elements) from main products ONLY
        // This is a main product, so remove ALL del elements
        const allDelElements = item.querySelectorAll('del');
        allDelElements.forEach(delEl => {
          delEl.remove();
        });
      }
    });
  }

  /**
   * @description Remove strikethrough (del elements) from main products ONLY. Add-ons MUST keep their strikethrough when they have discount.
   * This function is called aggressively to ensure strikethrough is always removed from main products. Also ensures quantity selector is visible for main products.
   * @author Renan Rodrigues
   */
  removeStrikethroughFromMainProducts() {
    if (!this.container) return;
    
    // Get all cart items
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on - be very explicit and check multiple ways
      const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
      const hasClass = item.classList.contains('cart-item-addon');
      
      // Also check product title as fallback
      const productLink = item.querySelector('.cart-product-link');
      const productTitle = productLink ? productLink.textContent.toLowerCase().trim() : '';
      // Fallback: title contains "add-on"/"addon" only. Primary addon detection is data-is-addon from Liquid (Easify _tpo_main_*).
      // const titleIsAddOn = productTitle.includes('add-on') || productTitle.includes('addon');
      const isAddOn = hasDataAttr || hasClass;
      
      if (isAddOn) {
        // This is an add-on - DO NOT REMOVE strikethrough, keep it visible
        // Add-ons should show strikethrough when they have discount
        // DO NOT TOUCH add-ons - skip completely
        return; // Skip this item completely - don't process add-ons
      }
      
      // This is a MAIN PRODUCT - process it
      // Remove ALL strikethrough elements from main products immediately
      const allDelElements = item.querySelectorAll('del');
      allDelElements.forEach(delEl => {
        // Remove immediately
        if (delEl.parentNode) {
          delEl.parentNode.removeChild(delEl);
        } else {
          delEl.remove();
        }
      });
      
      // Also apply CSS to hide any del elements that might appear (double protection)
      const remainingDelElements = item.querySelectorAll('del');
      remainingDelElements.forEach(delEl => {
        delEl.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; width: 0 !important; margin: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important; overflow: hidden !important; position: absolute !important; clip: rect(0, 0, 0, 0) !important; pointer-events: none !important;';
        // Also try to remove again
        setTimeout(() => {
          if (delEl.parentNode) {
            delEl.parentNode.removeChild(delEl);
          }
        }, 0);
      });
      
      // CRITICAL: Ensure quantity selector is visible and functional for main products
      const quantitySelector = item.querySelector('quantity-selector');
      if (quantitySelector) {
        // Remove any inline styles that might hide it
        quantitySelector.style.cssText = '';
        quantitySelector.style.display = 'inline-flex';
        quantitySelector.style.visibility = 'visible';
        quantitySelector.style.opacity = '1';
        quantitySelector.style.height = 'auto';
        quantitySelector.style.width = 'auto';
        quantitySelector.style.margin = '';
        quantitySelector.style.padding = '';
      }
      
      // Also ensure remove button is visible for main products
      const removeButton = item.querySelector('.remove');
      if (removeButton) {
        removeButton.style.cssText = '';
        removeButton.style.display = '';
        removeButton.style.visibility = 'visible';
        removeButton.style.opacity = '1';
      }
    });
  }
  
  /**
   * @description Disable add-on product links - make them non-clickable (plain text only). This ensures add-on chains are not clickable in the cart drawer
   * @author Renan Rodrigues
   */
  disableAddOnLinks() {
    if (!this.container) return;
    
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on - be very explicit and check multiple ways
      const hasDataAttr = item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true';
      const hasClass = item.classList.contains('cart-item-addon');
      
      // Also check product title as fallback
      const productLink = item.querySelector('.cart-product-link');
      const productTitle = productLink ? productLink.textContent.toLowerCase().trim() : '';
      // Fallback: title contains "add-on"/"addon" only. Primary addon detection is data-is-addon from Liquid (Easify _tpo_main_*).
      // const titleIsAddOn = productTitle.includes('add-on') || productTitle.includes('addon');
      const isAddOn = hasDataAttr || hasClass;
      
      if (isAddOn) {
        // This is an add-on - disable all links
        const links = item.querySelectorAll('a.cart-product-link');
        links.forEach(link => {
          // Remove href attribute
          link.removeAttribute('href');
          // Apply styles to disable pointer events
          link.style.cssText = 'cursor: default !important; pointer-events: none !important; text-decoration: none !important;';
          
          // Prevent click events
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }, true);
        });
      }
    });
  }

  /**
   * Stop continuous monitoring
   */
  stopStrikethroughRemovalMonitor() {
    if (this._strikethroughRemovalInterval) {
      clearInterval(this._strikethroughRemovalInterval);
      this._strikethroughRemovalInterval = null;
    }
  }

  /**
   * @description Style Swym Save for later links - no underline, larger font, and ensure they work as links. This function works for both regular products and add-ons. 
   * @author Renan Rodrigues
   */
  styleSwymSaveForLaterLinks() {
    if (!this.container) return;
    if (this.container.getAttribute('data-save-later-ui') === 'disabled') return;

    // MutationObserver only (no setInterval): polling was mutating the drawer DOM every 200ms
    // while the cart drawer stayed in the document, which could trigger Shopify shop_events_listener
    // to refetch /cart.js repeatedly and hurt LCP/TBT on PDP.
    if (!this.container.hasAttribute('data-save-later-observer')) {
      this.container.setAttribute('data-save-later-observer', 'true');
      this._saveLaterMutationRaf = null;
      this._saveLaterObserver = new MutationObserver(() => {
        if (!this.container || !this.container.classList.contains('active')) return;
        if (this._saveLaterMutationRaf != null) return;
        this._saveLaterMutationRaf = requestAnimationFrame(() => {
          this._saveLaterMutationRaf = null;
          this.removeSaveForLaterFromAddOns();
        });
      });
      this._saveLaterObserver.observe(this.container, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    
    // Initial removal
    this.removeSaveForLaterFromAddOns();
    
    const cartItems = this.container.querySelectorAll('.product-cart-item');
    
    cartItems.forEach(item => {
      // Check if this is an add-on
      const isAddOn = (item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true') ||
                     item.classList.contains('cart-item-addon');
      
      if (!isAddOn) {
        // For regular products: keep and style "Save for later" links
        // Use event delegation on the container to catch clicks on "Save for later" text
        if (!this.container.hasAttribute('data-save-later-delegation')) {
          this.container.setAttribute('data-save-later-delegation', 'true');
          this.container.addEventListener('click', (e) => {
            if (e.target.closest && e.target.closest('a.cart-product-link')) return;
            let target = e.target;
            
            // Walk up the DOM tree to find element containing "Save for later"
            while (target && target !== this.container) {
              const text = target.textContent?.trim() || target.innerText?.trim() || '';
              const hasSaveForLater = text.includes('Save for later') || text.includes('save for later');
              
              if (hasSaveForLater) {
                // Find the cart item
                const cartItem = target.closest('.product-cart-item');
                if (!cartItem) {
                  target = target.parentElement;
                  continue;
                }
                
                // Skip if it's an add-on
                const isAddOnItem = (cartItem.hasAttribute('data-is-addon') && cartItem.getAttribute('data-is-addon') === 'true') ||
                                  cartItem.classList.contains('cart-item-addon');
                if (isAddOnItem) {
                  return;
                }
                
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // Get product info
                const productLink = cartItem.querySelector('.cart-product-link');
                const productUrl = productLink ? productLink.getAttribute('href') : '';
                const productHandle = productUrl ? productUrl.split('/products/')[1]?.split('?')[0] : '';
                const quantitySelector = cartItem.querySelector('quantity-selector');
                const itemKey = quantitySelector ? quantitySelector.getAttribute('data-id') : null;
                const cartItemId = cartItem.getAttribute('id')?.replace('CartDrawerItem-', '');
                
                // Try Swym button first
                const swymButton = cartItem.querySelector('.swym-button[data-swaction="saveForLater"], .swym-save-for-later, a[href*="save-for-later"]');
                if (swymButton) {
                  swymButton.click();
                } else if (typeof _swat !== 'undefined' && _swat.saveForLater && productHandle) {
                  _swat.saveForLater({
                    epi: productHandle,
                    du: productUrl || `/products/${productHandle}`
                  });
                  
                  // Remove from cart
                  if (cartItemId) {
                    fetch(`/cart/change.js`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ line: parseInt(cartItemId), quantity: 0 })
                    }).then(() => {
                      if (typeof CartDrawer !== 'undefined') {
                        const cartDrawerInstance = getCartDrawerInstance();
                        cartDrawerInstance.refresh();
                      }
                    }).catch(() => {
                      if (itemKey) {
                        fetch('/cart/change.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ id: itemKey, quantity: 0 })
                        }).then(() => {
                          if (typeof CartDrawer !== 'undefined') {
                            const cartDrawerInstance = getCartDrawerInstance();
                            cartDrawerInstance.refresh();
                          }
                        });
                      }
                    });
                  } else if (itemKey) {
                    fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: itemKey, quantity: 0 })
                    }).then(() => {
                      if (typeof CartDrawer !== 'undefined') {
                        const cartDrawerInstance = getCartDrawerInstance();
                        cartDrawerInstance.refresh();
                      }
                    });
                  }
                }
                return; // Stop searching
              }
              target = target.parentElement;
            }
          }, true); // Use capture phase
        }
        
        // Style "Save for later" text to look clickable (only for regular products)
        const walker = document.createTreeWalker(
          item,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        
        let textNode;
        while (textNode = walker.nextNode()) {
          const text = textNode.textContent.trim();
          if (text === 'Save for later' || text === 'save for later') {
            const parent = textNode.parentNode;
            if (parent && parent.tagName !== 'A') {
              parent.style.cssText = 'text-decoration: none !important; font-size: 16px !important; color: #666 !important; cursor: pointer !important; pointer-events: auto !important;';
            }
          }
        }
        
        // Style existing Swym links
        const swymLinks = item.querySelectorAll('.swym-save-for-later, a[href*="save-for-later"], .swym-button.swym-save-for-later, .swym-button[data-swaction="saveForLater"], a.swym-save-for-later, [class*="swym"][class*="save"]');
        swymLinks.forEach(link => {
          link.style.cssText = 'text-decoration: none !important; font-size: 16px !important; color: #666 !important; cursor: pointer !important; pointer-events: auto !important;';
        });
      }
    });
  }
  
  /**
   * @description Remove "Save for later" text from add-ons ONLY.
   * @author Renan Rodrigues
   */
  removeSaveForLaterFromAddOns() {
    if (!this.container) return;
    if (this.container.getAttribute('data-save-later-ui') === 'disabled') return;

    // Find ONLY add-ons
    const addOnItems = this.container.querySelectorAll('.product-cart-item[data-is-addon="true"], .product-cart-item.cart-item-addon');
    
    addOnItems.forEach(item => {
      // Verify it's really an add-on
      const isAddOn = (item.hasAttribute('data-is-addon') && item.getAttribute('data-is-addon') === 'true') ||
                     item.classList.contains('cart-item-addon');
      
      if (!isAddOn) return; // Skip if not add-on
      
      // Remove text nodes containing "Save for later"
      const walker = document.createTreeWalker(
        item,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      
      let textNode;
      while (textNode = walker.nextNode()) {
        const text = textNode.textContent.trim();
        if (text === 'Save for later' || text === 'save for later') {
          const parent = textNode.parentNode;
          if (parent) {
            try {
              parent.removeChild(textNode);
              // Clean up empty parent
              if (parent.textContent.trim() === '' && parent.children.length === 0 && 
                  parent.tagName !== 'SCRIPT' && parent.tagName !== 'STYLE') {
                parent.remove();
              }
            } catch (e) {
              // Replace with empty text
              textNode.textContent = '';
            }
          }
        }
      }
      
      // Remove elements that contain ONLY "Save for later"
      const allElements = item.querySelectorAll('*');
      allElements.forEach(element => {
        const text = element.textContent?.trim() || '';
        if (text === 'Save for later' || text === 'save for later') {
          try {
            element.remove();
          } catch (e) {
            element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; font-size: 0 !important; line-height: 0 !important;';
          }
        }
      });
      
      // Remove all Swym links/buttons from add-ons
      const swymElements = item.querySelectorAll(
        '.swym-save-for-later, ' +
        'a[href*="save-for-later"], ' +
        '.swym-button[data-swaction="saveForLater"], ' +
        'a.swym-save-for-later, ' +
        '[class*="swym"][class*="save"]'
      );
      
      swymElements.forEach(element => {
        const text = element.textContent?.trim() || '';
        if (text.includes('Save for later') || text.includes('save for later')) {
          try {
            element.remove();
          } catch (e) {
            element.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; margin: 0 !important; padding: 0 !important; font-size: 0 !important;';
          }
        }
      });
    });
  }
}

/**
 * @updated 26/03/2026
 * @description Singleton: Create a global function to get a single instance of the cart drawer.
 * @author Renan Rodrigues
*/
function getCartDrawerInstance() {
  console.trace('[CartDrawer] get instance called');

  if (window.cartDrawerInstance) {
    console.log('[CartDrawer] reuse existing instance');
    return window.cartDrawerInstance;
  }

  console.log('[CartDrawer] create singleton instance');
  const drawer = new CartDrawer();
  window.cartDrawerInstance = drawer;

  return drawer;
}

/**
*  @class
*  @function FooterMenuToggle
*/
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle("active");
      });
    });
  }
}

/**
*  @class
*  @function CustomSelect
*/
if (!customElements.get("custom-select")) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.elements = {};
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.elements = {
        form: this.closest("form"),
        input: this.querySelector("input"),
        button: this.querySelector(".custom-select--button"),
        panel: this.querySelector(".custom-select--list"),
        facetFilterForm: document.querySelector("facet-filters-form"),
      };

      this.autoClose = this.dataset.autoClose === "true";

      if (this.elements.button) {
        this.elements.button.addEventListener("click", this.toggleSelector.bind(this));
        this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
        if (!this.querySelector(".sort-by-label") && this.querySelector(".ss__dropdown__button")) {
          this.elements.button.insertAdjacentHTML("beforebegin", `<span class="text-base whitespace-nowrap !text-[#2B2B2B] opacity-50 uppercase sort-by-label">sort by:</span>`);
        }
      }

      if (this.elements.facetFilterForm) {
        const getFirstForm = this.elements.facetFilterForm.querySelector("form#FacetFiltersForm-bar");
        const ssSlideoutDefaultDivWrapper = getFirstForm.querySelector("div:not(.thb-filter-sort-count)");
        const getDivElementWithClass = getFirstForm.querySelector("div.thb-filter-sort-count");

        if (ssSlideoutDefaultDivWrapper && getDivElementWithClass) {
          ssSlideoutDefaultDivWrapper.setAttribute("class", "flex items-center added-custom-js_custom-select");
          if (!ssSlideoutDefaultDivWrapper.querySelector("custom-select")) {
            ssSlideoutDefaultDivWrapper.insertAdjacentHTML("beforeend", getDivElementWithClass.outerHTML);
            if (ssSlideoutDefaultDivWrapper.querySelector("#ProductCount")) {
              ssSlideoutDefaultDivWrapper.querySelector("#ProductCount").remove();
            }
            const ssDropdownContent = ssSlideoutDefaultDivWrapper.querySelector(".ss__dropdown__content");
            const ssDropdownButtonLabel = ssSlideoutDefaultDivWrapper.querySelector(".ss__dropdown__button__label");
            const ssDropdownTheme = ssSlideoutDefaultDivWrapper.querySelector(".ss__dropdown--theme");
            const customSelect = ssSlideoutDefaultDivWrapper.querySelector("custom-select");
            const customSelectButton = ssSlideoutDefaultDivWrapper.querySelector(".custom-select--button");
            if (ssDropdownContent) {
              const getAllSsListOptions = ssDropdownContent.querySelectorAll(".ss__list__option");
              if (getAllSsListOptions && getAllSsListOptions.length > 0) {
                getAllSsListOptions.forEach((optionElement) => {
                  optionElement.addEventListener("click", () => {
                    getAllSsListOptions.forEach((el) => el.classList.remove("ss__active"));
                    optionElement.classList.add("ss__active");
                    const linkText = optionElement.querySelector("a").innerText;
                    if (linkText && ssDropdownButtonLabel) {
                      if (ssDropdownTheme && ssDropdownTheme.classList.contains("ss__dropdown--open")) {
                        ssDropdownTheme.classList.remove("ss__dropdown--open");
                      }

                      if (customSelect && customSelect.classList.contains("custom-select--active")) {
                        customSelect.classList.add("custom-select--active");
                      }

                      if (customSelectButton && customSelectButton.getAttribute("aria-expanded") === "true") {
                        customSelectButton.setAttribute("aria-expanded", "false");
                      }

                      ssDropdownButtonLabel.innerText = linkText;
                    }
                  });
                });
              }
            }
          }
        }
      }

      this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

      if (this.elements.panel) {
        this.elements.panel.querySelectorAll("button").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
      }
    }

    hidePanel() {
      if (this.elements.button) {
        this.elements.button.setAttribute("aria-expanded", "false");
      }
      this.classList.remove("custom-select--active");
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;
      this.hidePanel();
      if (this.elements.button) {
        this.elements.button.focus();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const selectedOption = event.currentTarget;

      if (this.elements.input) {
        this.elements.input.value = selectedOption.dataset.value;
        this.elements.input.dispatchEvent(new Event("change"));
      }

      if (this.elements.button) {
        const textLabel = this.elements.button.querySelector(".custom-select--text");
        if (textLabel) {
          textLabel.textContent = selectedOption.textContent;
        }
      }

      if (this.elements.form) {
        this.elements.form.dispatchEvent(new Event("input"));
      }

      if (this.autoClose) {
        this.hidePanel();
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle("custom-select--active");

      if (this.querySelector(".ss__dropdown--theme")) {
        this.querySelector(".ss__dropdown--theme").classList.toggle("ss__dropdown--open");
      }

      if (this.classList.contains("custom-select--active")) {
        if (this.elements.button) {
          this.elements.button.focus();
          this.elements.button.setAttribute("aria-expanded", "true");
        }
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains("custom-select--button");
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define("custom-select", CustomSelect);
}

/**
*  @class
*  @function LocalizationForm
*/
if (!customElements.get("localization-form")) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach((item) => item.addEventListener("change", this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define("localization-form", LocalizationForm);
}

/**
*  @class
*  @function SidePanelContentTabs
*/
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(".side-panel-content--tab-panel");
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
*  @class
*  @function CollapsibleRow
*/
if (!customElements.get("collapsible-row")) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");
      this.paymentMethodsIconsImagesContainer = this.querySelector("#payment-methods-icons-images-container");
      this.mainHeader = this.querySelector("#payment-methods-heading");
      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      this.paymentAnimation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector("summary").addEventListener("click", (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Sets overflow hidden on <details> element
      this.details.style.overflow = "hidden";
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        if (this.paymentMethodsIconsImagesContainer) {
          // Set initial state
          this.paymentMethodsIconsImagesContainer.style.display = "grid";
          this.paymentMethodsIconsImagesContainer.style.transition = "all 250ms cubic-bezier(0.4, 0, 0.2, 1)";
          this.paymentMethodsIconsImagesContainer.style.height = `${this.paymentMethodsIconsImagesContainer.scrollHeight}px`;
          this.paymentMethodsIconsImagesContainer.style.opacity = "1";

          // Force a reflow
          this.paymentMethodsIconsImagesContainer.offsetHeight;

          // Set final state
          this.paymentMethodsIconsImagesContainer.style.height = "0px";
          this.paymentMethodsIconsImagesContainer.style.opacity = "0";

          // Listen for transition end
          const handleTransitionEnd = () => {
            this.paymentMethodsIconsImagesContainer.style.display = "none";
            this.paymentMethodsIconsImagesContainer.style.height = "";
            this.paymentMethodsIconsImagesContainer.style.opacity = "";
            this.paymentMethodsIconsImagesContainer.style.transition = "";
            this.paymentMethodsIconsImagesContainer.removeEventListener("transitionend", handleTransitionEnd);
            this.open();
          };

          this.paymentMethodsIconsImagesContainer.addEventListener("transitionend", handleTransitionEnd);
        } else {
          this.open();
        }
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        if (this.paymentMethodsIconsImagesContainer) {
          // First close the accordion
          this.shrink();

          // Wait for accordion to close before showing payment methods
          const handleAccordionClose = () => {
            // Set initial state
            this.paymentMethodsIconsImagesContainer.style.display = "grid";
            this.paymentMethodsIconsImagesContainer.style.transition = "all 250ms ease-out";
            this.paymentMethodsIconsImagesContainer.style.height = "0px";
            this.paymentMethodsIconsImagesContainer.style.opacity = "0";

            // Force a reflow
            this.paymentMethodsIconsImagesContainer.offsetHeight;

            // Set final state
            this.paymentMethodsIconsImagesContainer.style.height = `${this.paymentMethodsIconsImagesContainer.scrollHeight}px`;
            this.paymentMethodsIconsImagesContainer.style.opacity = "1";

            // Listen for transition end
            const handleTransitionEnd = () => {
              this.paymentMethodsIconsImagesContainer.style.height = "auto";
              this.paymentMethodsIconsImagesContainer.style.transition = "";
              this.paymentMethodsIconsImagesContainer.removeEventListener("transitionend", handleTransitionEnd);
            };

            this.paymentMethodsIconsImagesContainer.addEventListener("transitionend", handleTransitionEnd);

            // Remove the accordion close listener
            this.details.removeEventListener("transitionend", handleAccordionClose);
          };

          this.details.addEventListener("transitionend", handleAccordionClose);
        } else {
          this.shrink();
        }
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 350,
          easing: "ease",
        }
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        }
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = "";
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}

/**
* @class
* @function ProductRecommendations
* 
* @update 26/03/2026
* @description Added a guard to prevent unnecessary product-recommendations fetch calls when `data-url` is missing, reducing console noise and avoiding redundant network and rendering work.
* @author Updated by Renan Rodrigues
*/
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  fetchProducts() {
    if (!this.dataset) {
      console.warn("product-recommendations: dataset is not available");
      return;
    }

    const rawUrl = this.dataset.url;
    const url = String(rawUrl || "").trim();

    if (
      !url ||
      url === "undefined" ||
      url === "null" ||
      url.includes("undefined") ||
      url.includes("null")
    ) {
      console.warn("product-recommendations: data-url attribute is missing or invalid:", rawUrl);
      return;
    }

    if (
      !url.startsWith("http") &&
      !url.startsWith("/") &&
      !url.startsWith("?")
    ) {
      console.warn("product-recommendations: Invalid URL:", url);
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if (this.querySelector(".swiper-container")) {
            this.initSwiperWhenVisible();
          }
        }

        this.classList.add("product-recommendations--loaded");
      })
      .catch((e) => {
        console.error(e);
      });
  }

  /**
   * @description Lazy load Swiper assets using IntersectionObserver to defer non-critical slider initialization and improve initial page load performance.
   * @updated 27/04/2026
   * @author Renan Rodrigues
   */

  initSwiperWhenVisible() {
    const swiperElement =
      this.querySelector(".swiper-container") ||
      this.querySelector(".swiper-container__recently-viewed");

    if (!swiperElement) return;

    if (!("IntersectionObserver" in window)) {
      this.loadSwiperAssets();
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          obs.disconnect();
          this.loadSwiperAssets();
        }
      });
    }, { rootMargin: "200px" });

    observer.observe(swiperElement);
  }

  loadSwiperAssets() {
    const swiperCssExists = document.querySelector('link[href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"]');
    const swiperJsExists = document.querySelector('script[src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"]');

    if (!swiperCssExists) {
      const swiperCss = document.createElement("link");
      swiperCss.rel = "stylesheet";
      swiperCss.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
      document.head.appendChild(swiperCss);
    }
    if (!swiperJsExists) {
      const swiperScript = document.createElement("script");
      swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      swiperScript.onload = () => {
        this.initializeSwiper();
      };
      document.head.appendChild(swiperScript);
    } else {
      // Ensure Swiper is available before initializing
      if (window.Swiper) {
        this.initializeSwiper();
      } else {
        // fallback if script is still loading
        setTimeout(() => {
          if (window.Swiper) {
            this.initializeSwiper();
          }
        }, 100);
      }
    }
  }

  initializeSwiper() {
    new Swiper(".swiper-container", {
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1440: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: ".swiper__btn_next__product_recommendation",
        prevEl: ".swiper__btn_prev__product_recommendation",
      },
    });
  }

  connectedCallback() {
    const url = String(this.dataset?.url || "").trim();

    if (!url || url === "undefined" || url === "null") {
      return;
    }

    this.fetchProducts();
  }
}

customElements.define("product-recommendations", ProductRecommendations);

/**
*  @class
*  @function ProductRecentlyViewed
*/
class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }

  // Function to generate product card HTML
  generateProductCard(product) {
    const compareAtPrice = product.compare_at_price || 0;
    const price = product.price || 0;

    let discountPercentage = 0;
    if (compareAtPrice > 0 && price > 0) {
      discountPercentage = Math.round((1 - price / compareAtPrice) * 100);
    }
    discountPercentage = Math.max(discountPercentage, 0);

    const isRingsSubCategory = product.tags.includes("Data SubCategory Rings");
    const hasFastDispatch = !isRingsSubCategory && product.tags.includes("Data FastDispatch");
    const dispatchBadgeTop = discountPercentage > 0 || isClearance ? "23px" : "0px";

    let isClearance = false;

    if (product.tags.includes("Data Clearance")) {
      isClearance = true;
    }

    let isInStoreOnly = false;

    if (!product.tags.includes("In Store None")) {
      if (
        (product.price < 3000 && product.tags.includes("Head Office Low")) ||
        (product.price < 10000 && product.tags.includes("Data Clearance") && product.tags.includes("Head Office Low")) ||
        product.id === 8229896683749
      ) {
        isInStoreOnly = true;
      }
    }

    let rrpLabel = "";
    if (
      !product.tags.includes("brand@Active Pro") &&
      (product.title.toLowerCase().includes("watch") ||
        product.tags.includes("Data Category Watches") ||
        product.tags.includes("brand@Disney") ||
        product.tags.includes("brand@Georgini") ||
        product.tags.includes("brand@Guess") ||
        product.tags.includes("brand@Thomas Sabo")) &&
      !product.tags.includes("Data Clearance")
    ) {
      rrpLabel = "RRP ";
    }

    let shouldColorBeRed = product.tags.includes("brand@Active Pro") || product.tags.includes("Data Clearance");

    const formatPrice = (amount) => {
      const dollars = amount / 100;
      return dollars % 1 === 0
        ? dollars.toLocaleString(undefined, { maximumFractionDigits: 0 })
        : dollars
            .toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
            .replace(/\.00$/, "");
    };
    const secondaryImageUrl = product.images[1] && product.images[1] !== product.images[0] ? product.images[1] : product.images[0];
    const isGiftCardProduct = product?.title?.toLowerCase()?.includes("gift card");

    const isWatchDepot = window.location.hostname.includes("watchdepot");

    return `
    <div class="swiper-slide">
      <product-card class="product-card text-center product-card--content-spacing-true product-card--border-false has-shadow--false !rounded-none">
        <figure class="product-featured-image thb-hover">
          <!-- Sale Badge -->
          ${
            !isClearance && discountPercentage > 0
              ? `<span class="badge onsale top left uppercase font-semibold !rounded-none" style="left: 0px !important; top: 0px !important; background-color: var(--color-badge-sale, #c62a32) !important; color: var(--color-badge-text, #fff) !important;">
                Save ${discountPercentage}%
              </span>`
              : ""
          }

          <!-- Clearance Badge -->
          ${
            isClearance
              ? `<span class="badge onsale top left uppercase font-semibold !rounded-none !bg-transparent" style="left: 0px!important; top: 0px!important; padding-left: 0!important;">
                  <div class="bg-[red] text-white p-3.5">
                    <span>
                      Clearance
                    </span>
                  </div>
                </span>`
              : ""
          }

          <!-- Fast Dispatch Badge -->
          ${
            hasFastDispatch
              ? `<span class="badge onsale top left uppercase font-semibold !rounded-none !bg-transparent" style="left: 0px !important; padding-left: 0 !important; top: ${dispatchBadgeTop} !important; z-index: 20;">
                  <div class="w-[25px] h-[18px] flex justify-center">
                    <img title="Fast Dispatch" width="auto" height="auto" alt="Fast Dispatch" src="https://cdn.shopify.com/s/files/1/0639/4989/7957/files/fast-dispatch.png?v=1659593526" />
                  </div>
                </span>`
              : ""
          }

          <!-- In-store Badge -->
          ${
            isInStoreOnly && !isWatchDepot
              ? `<span class="badge onsale top left uppercase font-semibold !rounded-none !bg-transparent" style="left: 0px !important; padding-left: 0 !important; top: ${
                  hasFastDispatch
                    ? discountPercentage > 0 || isClearance
                      ? "53px"
                      : "30px"
                    : discountPercentage > 0 || isClearance
                      ? "23px"
                      : "0px"
                } !important">
                  <div class="bg-white border-[1px] p-3.5 text-black">In-Store Only</div>
                </span>`
              : ""
          }
          <!-- Wishlist Button -->
          ${
            !isGiftCardProduct
              ? `
            <span class="badge onsale top right uppercase font-semibold !rounded-none !bg-transparent" style="top: 0px !important; right: 0px !important; padding: 0 !important">
              <button
                class="swym-button swym-icontext swym-loaded !px-0 swym-heart"
                data-with-epi="true"
                data-swaction="addToWishlist"
                data-product-id="${product.id}"
                data-variant-id="${product.variants[0].id}"
                data-product-url="${product.url}"
                aria-label="Add to Wishlist"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" class="size-6">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                  ></path>
                </svg>
              </button>
            </span>
            `
              : ""
          }

          <!-- Product Image Link -->
          <a
            href="${product.url}"
            title="${product.title}"
            class="product-featured-image-link aspect-ratio aspect-ratio--square"
            style="--padding-bottom: 100%"
          >
            <img
              class="product-secondary-image lazyautosizes ls-is-cached lazyloaded"
              width="1000"
              height="1000"
              data-sizes="auto"
              src="${secondaryImageUrl}"
              data-srcset="${secondaryImageUrl} 596w"
              fetchpriority="auto"
              alt="${product.title}"
              sizes="298px"
              srcset="${secondaryImageUrl} 298w, ${secondaryImageUrl} 596w"
            />
            <noscript>
              <img
                width="1000"
                height="1000"
                sizes="auto"
                src="${secondaryImageUrl}"
                srcset="${secondaryImageUrl} 298w, ${secondaryImageUrl} 596w"
                alt="${product.title}"
                fetchpriority="auto"
                loading="lazy"
              />
            </noscript>

            <img
              class="product-primary-image lazyautosizes ls-is-cached lazyloaded"
              width="1000"
              height="1000"
              data-sizes="auto"
              src="${product.images[0]}"
              data-srcset="${product.images[0]} 596w"
              fetchpriority="auto"
              alt="${product.title}"
              sizes="298px"
              srcset="${product.images[0]} 298w, ${product.images[0]} 596w"
            />
            <noscript>
              <img
                width="1000"
                height="1000"
                sizes="auto"
                src="${product.images[0]}"
                srcset="${product.images[0]} 298w, ${product.images[0]} 596w"
                alt="${product.title}"
                fetchpriority="auto"
                loading="lazy"
              />
            </noscript>

            ${
              !isInStoreOnly && window.__isQuickView
                ? `<quick-view class="product-card-quickview" data-product-handle="${product.handle}" tabindex="-1">
                    <div class="loading-overlay"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
                      </svg></div>
                    <span>Quick view</span>
                  </quick-view>`
                : ""
            }
          </a>
        </figure>

        <!-- Product Info -->
        <div class="product-card-info">
          <a
            href="${product.url}"
            title="${product.title}"
            class="product-card-title"
          >
            ${product.title}
          </a>
          <span class="price">
          ${rrpLabel}
            ${
              compareAtPrice !== 0
                ? `<del>
                    <span class="amount">$${formatPrice(compareAtPrice)}</span>
                  </del>`
                : ""
            }
            <ins>
              <span class="amount discounted">
                <span class="font-bold" style="${shouldColorBeRed ? "red!important" : "color: black!important"}">${isClearance ? "Now" : ""} $${formatPrice(price)}</span>
              </span>
            </ins>
          </span>
          ${
            product.rating !== 0
              ? `<div class="star-rating" style="--star-rating: ${product.rating}">
                  <span class="body-font">(${product.rating})</span>
                </div>`
              : ""
          }

          <div class="product-card--add-to-cart-button-wrapper">
          ${
            isInStoreOnly
              ? `<a href="${product.url}" class="product-card--add-to-cart-button button bg-transparent p-3" tabindex="-1" onmouseenter="this.style.backgroundColor='transparent'"
                  onmouseleave="this.style.backgroundColor='transparent'">
                  <span class="product-card--add-to-cart-text uppercase font-semibold">
                    ${isWatchDepot ? "Out of stock" : "in-store only"}
                  </span>
                </a>
            `
              : `<button
              class="product-card--add-to-cart-button product-card--add-to-cart-button-simple button accent p-3 rounded"
              data-product-id="${product.variants[0].id}"
              data-product-handle="${product.id}"
              tabindex="-1"
            >
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
              </svg>
              <span class="product-card--add-to-cart-text uppercase font-semibold">Add to cart</span>
            </button>`
          }

          </div>
        </div>
      </product-card>
    </div>
    `;
  }

  getProductsFromLocalStorage() {
    const storedData = JSON.parse(localStorage.getItem("__recently_viewed_products__"));
    if (storedData && storedData.length) {
      // Generate HTML for each product and append it to the swiper-wrapper
      const swiperWrapper = this.querySelector(".swiper-wrapper");
      if (swiperWrapper) {
        let html = "";

        storedData.forEach((product) => {
          if (product.price !== 0) {
            html += this.generateProductCard(product);
          }
        });

        swiperWrapper.innerHTML = html;
      }

      if (storedData.length <= 4 && window.innerWidth <= 1024) {
        const nextButton = this.querySelector(".swiper__btn_next__recent_products");
        const prevButton = this.querySelector(".swiper__btn_prev__recent_products");

        if (nextButton) {
          nextButton.style.display = "none";
        }

        if (prevButton) {
          prevButton.style.display = "none";
        }
      }

      if (this.querySelector(".swiper-container__recently-viewed")) {
        // this.initSwiperWhenVisible();
        this.loadSwiperAssets();
      }

      this.classList.add("product-recently-viewed--loaded");
    }
  }

  loadSwiperAssets() {
    const swiperCssExists = document.querySelector('link[href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"]');
    const swiperJsExists = document.querySelector('script[src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js"]');

    if (!swiperCssExists) {
      // Load Swiper CSS
      const swiperCss = document.createElement("link");
      swiperCss.rel = "stylesheet";
      swiperCss.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
      document.head.appendChild(swiperCss);
    }

    if (!swiperJsExists) {
      // Load Swiper JS and initialize Swiper after loading
      const swiperScript = document.createElement("script");
      swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      swiperScript.onload = () => {
        this.initializeSwiper();
      };
      document.head.appendChild(swiperScript);
    } else {
      this.initializeSwiper();
    }
  }

  initializeSwiper() {
    new Swiper(".swiper-container__recently-viewed", {
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1440: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: ".swiper__btn_next__recent_products",
        prevEl: ".swiper__btn_prev__recent_products",
      },
    });
  }

  connectedCallback() {
    this.initWhenVisible();
  }
  
  initWhenVisible() {
    if (!("IntersectionObserver" in window)) {
      this.getProductsFromLocalStorage();
      
      return;
    }
  
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            obs.disconnect();
            this.getProductsFromLocalStorage();
          }
        });
      },
      {
        rootMargin: "600px",
      }
    );
  
    observer.observe(this);
  }
}

customElements.define("product-recently-viewed", ProductRecentlyViewed);

/**
*  @class
*  @function EmbeddedFormWrapper
*/

if (!customElements.get("embedded-form-wrapper")) {
  class EmbeddedFormWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.embeddedForm = this.querySelector("form-embed");
      if (this.embeddedForm) {
        this.handleEmbeddedForm();
      } else {
        this.waitForEmbeddedForm();
      }
    }

    waitForEmbeddedForm() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeName === "SHOPIFY-FORMS-EMBED") {
              this.embeddedForm = node;
              observer.disconnect();
              this.handleEmbeddedForm();
            }
          });
        });
      });

      observer.observe(this, { childList: true, subtree: true });
    }

    handleEmbeddedForm() {
      if (this.embeddedForm && this.embeddedForm.shadowRoot) {
        const shadowRoot = this.embeddedForm.shadowRoot;
        const formElement = shadowRoot.querySelector("form");
        if (formElement) {
          let sectionFormWrapper = shadowRoot.querySelector(`section[data-sizing="form-wrapper"]`);
          let findEmailCheckBox = shadowRoot.querySelector(`input[value="Email"]`);
          sectionFormWrapper.style.maxWidth = "unset";
          let findStoreInputField = shadowRoot.querySelector(`input[id*="#store"]`);
          let getStoreInputParentDiv = findStoreInputField.closest("div");

          if (findEmailCheckBox) {
            findEmailCheckBox.checked = true;
            findEmailCheckBox.dispatchEvent(new Event("change", { bubbles: true }));
            findEmailCheckBox.addEventListener("change", (event) => {
              if (!findEmailCheckBox.checked) {
                findEmailCheckBox.checked = true;
                findEmailCheckBox.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
          }

          if (getStoreInputParentDiv) {
            getStoreInputParentDiv.style.display = "none";
            // find query parameter
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const storeValue = urlParams.get("store");
            // run validation
            if (findStoreInputField) {
              if (storeValue) {
                findStoreInputField.value = storeValue;
                findStoreInputField.setAttribute("value", storeValue);
                findStoreInputField.dispatchEvent(new Event("input", { bubbles: true }));
                findStoreInputField.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
          }
        }
      }
    }
  }

  customElements.define("embedded-form-wrapper", EmbeddedFormWrapper);
}

/**
*  @class
*  @function QuickView
*/
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture--product");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      this.addEventListener("click", this.setupEventListener.bind(this));
      this.cc.addEventListener("click", this.setupCCEventListener.bind(this));
    }
    setupCCEventListener(e) {
      const stickyHeader = document.querySelector(".header--sticky");
      this.body.classList.remove("open-cc--product");
      this.drawer.classList.remove("active");

      if (stickyHeader && stickyHeader.classList.contains("hidden")) {
        stickyHeader.classList.remove("hidden");
      }

      setTimeout(() => {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML = "";
      }, 260);
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector("#Product-Drawer-Content").querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc--product");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          let slider = this.drawer.querySelector("#Product-Slider");

          slider.reInit();
          window.dispatchEvent(new Event("resize"));
        }, 100);

        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
*  @class
*  @function AnimatedMarkers
*/
class AnimatedMarkers {
  constructor() {
    this.markers = document.querySelectorAll(".svg-marker path");
    this.animations_enabled = document.body.classList.contains("animations-true") && typeof gsap !== "undefined";

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: "power4.inOut",
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: "top 70%",
          end: "bottom 80%",
        },
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof CartDrawer !== "undefined") {
    const isPdp = window.location.pathname.includes("/products/");
    const hasProductOptions = document.querySelector("product-options-section");
  
    if (!isPdp || !hasProductOptions) {
      window.cartDrawerInstance = getCartDrawerInstance();
    }
  }
  if (typeof AnimatedMarkers !== "undefined") {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }

  let cartInitDone = false;

  document.addEventListener(
    "click",
    function (event) {
      if (cartInitDone) return;

      const cartTrigger = event.target.closest(
        "#cart-drawer-toggle, #cart-drawer-toggle-desktop, .addToCartCustomButton, [name='add'], button[type='submit']"
      );

      if (!cartTrigger) return;

      if (typeof CartDrawer !== "undefined" && !window.cartDrawerInstance) {
        window.cartDrawerInstance = getCartDrawerInstance();
        cartInitDone = true;
      }
    },
    true
  );

  // DropInBlog product widget title and image clickable to product page
  const widgets = document.querySelectorAll(".dib-prod");
  widgets.forEach((widget) => {
    const titleElement = widget.querySelector("h2.dib-prod-title");

    if (titleElement) {
      titleElement.textContent = titleElement.textContent.toUpperCase();
    }

    const productURL = widget.childNodes[7].firstElementChild.getAttribute("href");
    const elementHTML = widget.innerHTML;
    const newElementHTML = `<a href="${productURL}">${elementHTML}</a>`;
    widget.innerHTML = newElementHTML;
  });

  const productOptionsSection = document.querySelector("product-options-section");

  let pdpEasifyHandlersInitialized = false;

  function initPdpEasifyHandlers() {
    if (pdpEasifyHandlersInitialized) return;
    pdpEasifyHandlersInitialized = true;
    
    setInterval(() => {
      const getInput = productOptionsSection.querySelector("input.text-input");
      const getAddToCartButton = productOptionsSection.querySelector("button.addToCartCustomButton");
      if (getInput && getAddToCartButton) {
        getAddToCartButton.disabled = !getInput.value.trim();
        getInput.addEventListener("input", () => {
          getAddToCartButton.disabled = !getInput.value.trim();
        });
      }
    }, 1000);

    // When drawer closes (after add without add-on or after opening My Bag), Easify dropdown (tpo_option-dropdown) can stay frozen:
    // focus was in drawer, or Easify's handler never ran. Re-enable the form and all Easify option elements.
    document.addEventListener('cart-drawer:closed', function unfreezeEasifyAfterDrawerClose() {
      // Release focus from drawer first so PDP is interactive
      if (document.body.contains(document.activeElement) && document.activeElement.closest && document.activeElement.closest('#Cart-Drawer')) {
        document.body.focus();
      }
      // Run unfreeze after delay so drawer close animation and focus release complete
      setTimeout(function() {
        var section = document.querySelector("product-options-section");
        if (!section) return;
        dispatchCustomEvent('cart:updated');
        // Standard form elements
        section.querySelectorAll('select, [role="listbox"], [role="combobox"], input, button').forEach(function(el) {
          el.removeAttribute('disabled');
          el.removeAttribute('aria-disabled');
          if (el.getAttribute('tabindex') === '-1') el.setAttribute('tabindex', '0');
          el.style.pointerEvents = '';
          el.style.visibility = '';
        });
        // Easify option dropdown/input (tpo_option-input, tpo_option-dropdown) – often the frozen list
        section.querySelectorAll('.tpo_option-input, .tpo_option-dropdown, [class*="tpo_option"]').forEach(function(el) {
          el.removeAttribute('disabled');
          el.removeAttribute('aria-disabled');
          el.removeAttribute('aria-expanded');
          if (el.getAttribute('tabindex') === '-1') el.setAttribute('tabindex', '0');
          el.style.pointerEvents = '';
          el.style.visibility = '';
          el.style.display = '';
        });
        section.style.pointerEvents = '';
        section.style.visibility = '';
      }, 250);
    });

    // B2: Intercept easify options add to cart button to open drawer immediately
    // Monitor for the add to cart button and intercept its click
    let easifyButtonCheckInterval = setInterval(() => {
      const addToCartButton = productOptionsSection.querySelector("button.addToCartCustomButton");
      if (addToCartButton && !addToCartButton.hasAttribute("data-easify-intercepted")) {
        addToCartButton.setAttribute("data-easify-intercepted", "true");
        
        // Intercept click event - use capture phase to run BEFORE easify's handler
        addToCartButton.addEventListener("click", function(easifyEvent) {
          // Prevent default behavior FIRST
          easifyEvent.preventDefault();
          easifyEvent.stopPropagation();
          easifyEvent.stopImmediatePropagation();
          
          // Set flags FIRST to prevent any navigation
          window._preventCartReload = true;
          window._easifyAddToCartInProgress = true;
          
          // Open drawer IMMEDIATELY when button is clicked (BEFORE easify processes)
          const cartDrawer = document.getElementById("Cart-Drawer");
          if (cartDrawer) {
            // Force open drawer immediately with multiple methods
            document.body.classList.add("open-cc");
            cartDrawer.classList.add("active");
            cartDrawer.focus();
            dispatchCustomEvent("cart-drawer:open");
            
            // Also force it with inline styles as backup
            cartDrawer.style.display = "block";
            cartDrawer.style.visibility = "visible";
            cartDrawer.style.opacity = "1";
            cartDrawer.style.zIndex = "9999";
          }
          
          // Keep flags active for longer to prevent any delayed navigation
          setTimeout(() => {
            window._preventCartReload = false;
            window._easifyAddToCartInProgress = false;
          }, 8000); // Increased to 8 seconds
          
          // Now manually trigger easify's add to cart logic via fetch
          // Find the form associated with this button
          const form = addToCartButton.closest("form") || document.querySelector("form[action*='/cart/add']");
          if (form) {
            const formData = new FormData(form);
            
            // Make AJAX request to add to cart
            fetch("/cart/add.js", {
              method: "POST",
              body: formData,
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Accept": "application/json"
              }
            })
            .then(response => response.json())
            .then(data => {
              if (!data.status) {
                // Success - refresh cart drawer
                if (typeof CartDrawer !== "undefined") {
                  const cartDrawerInstance = getCartDrawerInstance();
                  cartDrawerInstance.refresh();
                  cartDrawerInstance.hideQuantitySelectorForAddOns();

                  // Ensure drawer stays open
                  const cartDrawer = document.getElementById("Cart-Drawer");
                  if (cartDrawer) {
                    document.body.classList.add("open-cc");
                    cartDrawer.classList.add("active");
                    cartDrawer.style.display = "block";
                    cartDrawer.style.visibility = "visible";
                    cartDrawer.style.opacity = "1";
                  }
                }
              }
            })
            .catch(error => {
              console.error("Error adding to cart:", error);
            });
          }
          
          // Intercept ALL form submissions globally to prevent reload
          const handleFormSubmit = function(e) {
            if (window._easifyAddToCartInProgress || window._preventCartReload) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              return false;
            }
          };
          
          // Add listener to all existing forms
          const forms = document.querySelectorAll("form");
          forms.forEach(form => {
            form.removeEventListener("submit", handleSubmit, true);
            form.addEventListener("submit", handleFormSubmit, true);
          });
          
          // Also intercept at document level to catch dynamically added forms
          document.removeEventListener("submit", handleFormSubmit, true);
          document.addEventListener("submit", handleFormSubmit, true);
          
          /**
           * @description Monitor for cart updates and refresh drawer aggressively. Check for 6 seconds (60 * 100ms).
           * 
           * @updated 27/03/2026
           * @updateDescription Replace setInterval from 100 to 300ms to reduce CPU usage while maintaining good user experience. 
           * @author Updated by Renan Rodrigues
           */
          let checkCount = 0;
          const maxChecks = 60;
          const checkCartUpdate = setInterval(() => {
            checkCount++;

            // Force drawer open on every check
            const cartDrawer = document.getElementById("Cart-Drawer");
            if (cartDrawer) {
              document.body.classList.add("open-cc");
              cartDrawer.classList.add("active");
              cartDrawer.style.display = "block";
              cartDrawer.style.visibility = "visible";
              cartDrawer.style.opacity = "1";
            }

            // Refresh cart drawer periodically
            if (typeof CartDrawer !== "undefined") {
              const cartDrawerInstance = getCartDrawerInstance();
              cartDrawerInstance.refresh();
              cartDrawerInstance.hideQuantitySelectorForAddOns();
            }

            // Stop checking after max attempts
            if (checkCount >= maxChecks) {
              clearInterval(checkCartUpdate);
            }
          }, 300);
        }, true); // Use capture phase to intercept before easify
        
        // Clear interval once button is found and intercepted
        clearInterval(easifyButtonCheckInterval);
      }
    }, 500);
    
    // Also use MutationObserver as backup to catch button if it's added dynamically
    const easifyButtonObserver = new MutationObserver((mutations) => {
      const addToCartButton = productOptionsSection.querySelector("button.addToCartCustomButton");
      if (addToCartButton && !addToCartButton.hasAttribute("data-easify-intercepted")) {
        addToCartButton.setAttribute("data-easify-intercepted", "true");
        
        // Intercept click event with same aggressive approach
        addToCartButton.addEventListener("click", function(easifyEvent) {
          const cartDrawer = document.getElementById("Cart-Drawer");
          if (cartDrawer) {
            document.body.classList.add("open-cc");
            cartDrawer.classList.add("active");
            cartDrawer.focus();
            cartDrawer.style.display = "block";
            cartDrawer.style.visibility = "visible";
            cartDrawer.style.opacity = "1";
            dispatchCustomEvent("cart-drawer:open");
            
            window._preventCartReload = true;
            window._easifyAddToCartInProgress = true;
            setTimeout(() => {
              window._preventCartReload = false;
              window._easifyAddToCartInProgress = false;
            }, 5000);
          }
        }, true);
      }
    });

    easifyButtonObserver.observe(productOptionsSection, {
      childList: true,
      subtree: true
    });
    
    // Also intercept at the product-options-section level
    productOptionsSection.addEventListener("click", function(e) {
      if (e.target && e.target.classList && e.target.classList.contains("addToCartCustomButton")) {
        const cartDrawer = document.getElementById("Cart-Drawer");
        if (cartDrawer) {
          document.body.classList.add("open-cc");
          cartDrawer.classList.add("active");
          cartDrawer.focus();
          cartDrawer.style.display = "block";
          cartDrawer.style.visibility = "visible";
          cartDrawer.style.opacity = "1";
          dispatchCustomEvent("cart-drawer:open");
        }
      }
    }, true);
    
    // Also listen for any custom events that easify might fire
    document.addEventListener("cart:updated", () => {
      const cartDrawer = document.getElementById("Cart-Drawer");
      if (cartDrawer) {
        document.body.classList.add("open-cc");
        cartDrawer.classList.add("active");
        if (typeof CartDrawer !== "undefined") {
          const cartDrawerInstance = getCartDrawerInstance();
          cartDrawerInstance.refresh();
        }
      }
    });
    
    // Monitor cart count changes as another indicator
    let lastCartCount = 0;

    const cartCountCheck = setInterval(() => {
      const cartCountElements = document.querySelectorAll('.thb-item-count');
      if (cartCountElements.length > 0) {
        const currentCount = parseInt(cartCountElements[0].textContent) || 0;
        if (currentCount > lastCartCount && lastCartCount > 0) {
          // Cart count increased, open drawer immediately
          const cartDrawer = document.getElementById("Cart-Drawer");
          if (cartDrawer) {
            document.body.classList.add("open-cc");
            cartDrawer.classList.add("active");
            cartDrawer.focus();
            dispatchCustomEvent("cart-drawer:open");
            if (typeof CartDrawer !== "undefined") {
              const cartDrawerInstance = getCartDrawerInstance();
              cartDrawerInstance.refresh();
              cartDrawerInstance.hideQuantitySelectorForAddOns();
            }
          }
        }
        lastCartCount = currentCount;
      }
    }, 200);
    
    // Also monitor for changes in cart drawer content (when items are added)
    const cartDrawer = document.getElementById("Cart-Drawer");

    if (cartDrawer) {
      const cartContentObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            // Check if a product item was added
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList && node.classList.contains("product-cart-item")) {
                // A product was added to cart, open drawer if not already open
                if (!cartDrawer.classList.contains("active")) {
                  document.body.classList.add("open-cc");
                  cartDrawer.classList.add("active");
                  cartDrawer.focus();
                  dispatchCustomEvent("cart-drawer:open");
                  if (typeof CartDrawer !== "undefined") {
                    const cartDrawerInstance = getCartDrawerInstance();
                    cartDrawerInstance.refresh();
                    cartDrawerInstance.hideQuantitySelectorForAddOns();
                  }
                }
              }
            });
          }
        });
      });
      
      cartContentObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
  }

  if (
    productOptionsSection &&
    !(window.location.pathname.includes("digital-gift-card") || window.location.pathname.includes("gift-card"))
  ) {
    const initOnInteraction = () => initPdpEasifyHandlers();

    productOptionsSection.addEventListener("pointerdown", initOnInteraction, { once: true, capture: true });
    productOptionsSection.addEventListener("focusin", initOnInteraction, { once: true, capture: true });

    const addToCartButton = productOptionsSection.querySelector("button.addToCartCustomButton");
    if (addToCartButton) {
      addToCartButton.addEventListener("pointerdown", initOnInteraction, { once: true, capture: true });
    }
  }
});

// product variant selector
function toggleDropdown(element) {
  const fieldset = element.closest("fieldset");
  const dropdown = fieldset.querySelector("ul") || document.querySelector("#dropdown-items");
  const wrapper = fieldset.querySelector("#dropdown_wrapper");
  const quickViewWrapper = document.querySelector("#quick-view-dropdown_wrapper");
  const AddToCartStickyWrapper = document.querySelector("#add-to-cart-sticky-dropdown_wrapper");

  if (dropdown.classList.contains("!hidden")) {
    const rect = wrapper.getBoundingClientRect();

    // Set dropdown width equal to the wrapper width
    dropdown.style.width = `${rect.width}px`;
    // Adjusts top and left position based on quick view wrapper existence
    if (quickViewWrapper && element.parentNode.parentNode.parentNode.id === "quick-view-dropdown_wrapper") {
      dropdown.style.position = "relative";
    } else if (AddToCartStickyWrapper && element.parentNode.parentNode.parentNode.id === "add-to-cart-sticky-dropdown_wrapper") {
      dropdown.style.position = "relative";
      dropdown.style.maxHeight = "200px";
      dropdown.style.height = "100%";
      dropdown.style.overflowY = "auto";
      dropdown.style.overflowX = "hidden";
      const formLabel = fieldset.querySelector(".form__label");
      const arrowElement = fieldset.querySelector(".arrow");
      if (formLabel) {
        formLabel.style.order = "2";
      }
      if (arrowElement) {
        arrowElement.style.rotate = "180deg";
      }
    } else {
      dropdown.style.top = `${rect.bottom + window.scrollY + 10}px`;
      dropdown.style.left = `${rect.left + window.scrollX}px`;
    }

    dropdown.classList.remove("!hidden");

    const dropdownItems = dropdown.querySelectorAll("li");
    dropdownItems.forEach((item) => {
      item.addEventListener("click", () => {
        dropdown.classList.add("!hidden");
      });
    });

    document.addEventListener("click", function handleClickOutside(event) {
      if (!wrapper.contains(event.target) && !dropdown.contains(event.target)) {
        dropdown.classList.add("!hidden");
        document.removeEventListener("click", handleClickOutside);
      }
    });
  } else {
    dropdown.classList.add("!hidden");
    if (AddToCartStickyWrapper && element.parentNode.parentNode.parentNode.id === "add-to-cart-sticky-dropdown_wrapper") {
      const arrowElement = fieldset.querySelector(".arrow");
      if (arrowElement) {
        arrowElement.style.rotate = "0deg";
      }
    }
  }
}

let lastScrollY = window.scrollY;
let windowInnerWidth = window.innerWidth;
let frameScheduled = false;

const stickyHeader = document.querySelector(".header--sticky");
const mainContent = document.querySelector("#main-content");
const headerPlaceholder = document.querySelector("#header-placeholder");

window.addEventListener("resize", function () {
  windowInnerWidth = window.innerWidth;
});

window.addEventListener(
  "scroll",
  function () {
    if (frameScheduled) {
      return;
    }

    frameScheduled = true;

    requestAnimationFrame(() => {
      frameScheduled = false;

      if (windowInnerWidth > 1068 && stickyHeader) {
        const getTimerSection = stickyHeader.querySelector(".section-countdown-banner");
        if (getTimerSection) {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          if (scrollTop > 0) {
            getTimerSection.classList.add("!hidden");
          } else {
            if (getTimerSection.classList.contains("!hidden")) {
              getTimerSection.classList.remove("!hidden");
            }
          }
        }
      } else {
        const headerHeight = stickyHeader.offsetHeight;
        const currentScrollY = window.scrollY;

        stickyHeader.classList.add("transition-transform", "duration-300", "ease-in-out");

        if (currentScrollY === 0) {
          stickyHeader.classList.remove("-translate-y-full", "fixed");
          stickyHeader.classList.add("translate-y-0", "relative");
          headerPlaceholder.style.height = `0px`;
        } else if (currentScrollY < lastScrollY) {
          stickyHeader.classList.remove("-translate-y-full", "relative");
          stickyHeader.classList.add("translate-y-0", "fixed", "top-0", "left-0", "w-full");
          headerPlaceholder.style.height = `${headerHeight}px`;
        } else if (currentScrollY > headerHeight) {
          stickyHeader.classList.remove("translate-y-0", "fixed", "top-0", "left-0", "w-full");
          stickyHeader.classList.add("-translate-y-full", "relative");
          mainContent.style.marginTop = "0";
          headerPlaceholder.style.height = `0px`;
        }

        // Update the last scroll position
        lastScrollY = currentScrollY;
      }
    });
  },
  {
    passive: true,
  }
);

// DropInBlog embedded product - script started
if (window.location.href.includes("/blog/")) {
  const getAllEmbeddedPrice = document.querySelectorAll("#dib-posts .dib-prod-price");

  if (getAllEmbeddedPrice?.length > 0) {
    getAllEmbeddedPrice.forEach(async (productPrice) => {
      try {
        const findClosedATag = productPrice.closest("a") || productPrice.closest(".dib-prod")?.querySelector("a");

        if (findClosedATag) {
          const getHrefAttribute = findClosedATag.getAttribute("href");

          if (getHrefAttribute) {
            const productResponse = await fetch(`${getHrefAttribute}.js`);

            if (!productResponse.ok) {
              console.error(`Failed to fetch this product: ${getHrefAttribute}`);
              return;
            }

            const productData = await productResponse.json();

            const { variants } = productData;

            if (variants?.length > 0) {
              variants.forEach((variant) => {
                const { title, price, compare_at_price, name } = variant;
                if (title && (title.trim().toLowerCase() === "no chain" || name.trim().toLowerCase().includes("no resize"))) {
                  const buildNewPrice = `$${Number(price / 100).toFixed(2)} ${compare_at_price ? `<s>$${Number(compare_at_price / 100).toFixed(2)}</s>` : ""}`;
                  productPrice.innerHTML = buildNewPrice;
                }
              });
            }
          }
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    });
  }
}

// DropInBlog embedded product - script ended
// Fix vip signup Shopify Forms teaser z-index
const shopifyFormZFixObserver = new MutationObserver(shopifyFormZFixMutations => {
  shopifyFormZFixMutations.forEach(shopifyFormZFixMutation => {
    if (shopifyFormZFixMutation.type === 'childList' && shopifyFormZFixMutation.addedNodes.length > 0) {
      shopifyFormZFixMutation.addedNodes.forEach(shopifyFormZFixNode => {
        if (shopifyFormZFixNode.nodeType === Node.ELEMENT_NODE) {
          // Match any app-embed-container (id can be non-string in some contexts, so check type)
          const nodeId = shopifyFormZFixNode.id;
          const isAppEmbedContainer =
            (typeof nodeId === 'string' && nodeId.startsWith('app-embed-container-')) ||
            (shopifyFormZFixNode.matches && shopifyFormZFixNode.matches('[id^="app-embed-container-"]'));
          if (isAppEmbedContainer) {
            const shopifyFormZFixShadowHost = shopifyFormZFixNode;
            const shopifyFormZFixShadowRoot = shopifyFormZFixShadowHost.shadowRoot;

            if (shopifyFormZFixShadowRoot) {
              // Find the #app-embed element inside the shadow DOM
              const shopifyFormZFixAppEmbed = shopifyFormZFixShadowRoot.querySelector('#app-embed');

              if (shopifyFormZFixAppEmbed) {
                const shopifyFormZFixCurrentZIndex = parseInt(window.getComputedStyle(shopifyFormZFixAppEmbed).zIndex);

                // Only override if z-index is unreasonably high
                if (shopifyFormZFixCurrentZIndex > 40) {
                  const shopifyFormZFixStyleElement = document.createElement('style');
                  shopifyFormZFixStyleElement.textContent = `
                      #app-embed {
                          z-index: 40 !important;
                      }
                  `;
                  shopifyFormZFixShadowRoot.appendChild(shopifyFormZFixStyleElement);
                }

                // Stop observing once we've checked it
                shopifyFormZFixObserver.disconnect();
              }
            }
          }
        }
      });
    }
  });
});

const shopifyFormZFixTargetNode = document.body;
const shopifyFormZFixConfig = { childList: true, subtree: true };
shopifyFormZFixObserver.observe(shopifyFormZFixTargetNode, shopifyFormZFixConfig);

(function () {
  if (typeof document === "undefined") return;
  document.addEventListener(
    "click",
    function (e) {
      var drawer = document.getElementById("Cart-Drawer");
      var removing = drawer && drawer.classList.contains("cart-drawer-removing");
      if (!removing && !window._cartDrawerRemovalInProgress) return;
      var link = e.target && e.target.closest && e.target.closest("#Cart-Drawer .cart-drawer-view-bag-link, #Cart-Drawer .cart-drawer-buttons a[href*='cart']");
      if (!link || link.closest("form")) return;
      e.preventDefault();
      e.stopPropagation();
    },
    true
  );
})();